class APIRequestError extends Error {
  constructor(responseText, contentType, status, statusText) {
    super();

    //this.message = (responseText.ExceptionMessage || responseText.Message) || responseText;
    if (contentType) {
      switch (contentType) {
        case "json":
          this.response = JSON.parse(responseText);
          break;
        default:
          try {
            responseText = JSON.parse(responseText);
            this.response = responseText;
          } catch (e) {
            this.response = responseText; //{ Message: responseText, ExceptionMessage: responseText };
          }
          break;
      }
    } else {
      try {
        responseText = JSON.parse(responseText);
        this.response = responseText;
      } catch (e) {
        this.response = responseText; //{ Message: responseText, ExceptionMessage: responseText };
      }
    }
    this.responseType = contentType;
    this.status = status;
    this.statusText = statusText;
  }
  //constructor(responseText, responseType, status, statusText) {
  //    super();

  //    // Since response and responseType=json isn't supported yet, default to parse
  //    // json return result.
  //    this.responseText = responseText;
  //    if (responseText) {
  //        switch (responseType) {
  //            default:
  //                this.response = JSON.parse(responseText);
  //        }
  //    } else {
  //        this.response = {};
  //    }

  //    this.responseType = responseType;
  //    this.status = status;
  //    this.statusText = statusText;
  //}

  get name() {
    return this.constructor.name;
  }
}

class JobProAPI {
  static get APIRequestError() {
    return APIRequestError;
  }

  constructor(apiLocation, oauthToken, options) {
    if (arguments.length === 2) {
      options = oauthToken;
      oauthToken = "";
    }

    if (!options) {
      options = {};
    }

    this._apiLocation = apiLocation;
    this._useCors = options.useCors;
    this._oauthToken =
      typeof oauthToken === "string" ? Promise.resolve(oauthToken) : oauthToken;

    this.attachments = new AttachmentRepository(this);
    this.bidCategories = new BidCategoryRepository(this);
    this.bids = new BidRepository(this);
    this.rValue = new RValueRepository(this);
    this.financeCharge = new FinanceChargeRepository(this);
    this.bidItemMultipliers = new BidItemMultipliersRepository(this);
    this.bidTypes = new BidTypeRepository(this);
    this.calendar = new CalendarRepository(this);
    this.calendarPeriods = new CalendarPeriodsRepository(this);
    this.checklistDefintiions = new ChecklistDefinitionRepository(this);
    this.commissionPlans = new CommissionPlanRepository(this);
    this.commissionRates = new CommissionRateRepository(this);
    this.companyNetTerms = new CompanyNetTermRepository(this);
    this.companyTaxStatuses = new CompanyTaxStatusRepository(this);
    this.contacts = new ContactRepository(this);
    this.countries = new CountryRepository(this);
    this.currentUser = new CurrentUserRepository(this);
    this.customers = new CustomerRepository(this);
    this.customerCategories = new CustomerCategoryRepository(this);
    this.customerDocumentTemplates = new CustomerDocumentTemplateRepository(
      this
    );
    this.customerStatuses = new CustomerStatusRepository(this);
    this.datasheets = new DataSheetRepository(this);
    this.employees = new EmployeeRepository(this);
    this.equipment = new EquipmentRepository(this);
    this.equipmentStatuses = new EquipmentStatusRepository(this);
    this.equipmentTypes = new EquipmentTypesRepository(this);
    this.financePrograms = new FinanceProgramRepository(this);
    this.financeCharge = new FinanceChargeRepository(this);
    this.globalLaborCodes = new GlobalLaborCodeRepository(this);
    this.inventory = new InventoryRepository(this);
    this.inventoryTransactions = new InventoryTransactionRepository(this);
    this.invoices = new InvoiceRepository(this);
    this.invoiceTemplates = new InvoiceTemplateRepository(this);
    this.items = new ItemRepository(this);
    this.jobs = new JobRepository(this);
    this.jobDocumentTemplates = new JobDocumentTemplateRepository(this);
    this.jobStatuses = new JobStatusRepository(this);
    this.jobTypes = new JobTypeRepository(this);
    this.appointmentTypes = new AppointmentTypeRepository(this);
    this.laborMultipliers = new LaborMultiplierRepository(this);
    this.manufacturers = new ManufacturerRepository(this);
    this.materialMultipliers = new MaterialMultiplierRepository(this);
    this.merchantServices = new MerchantServicesRepository(this);
    this.noteTemplates = new NoteTemplateRepository(this);
    this.offices = new OfficeRepository(this);
    this.payments = new PaymentRepository(this);
    this.payrollDocumentTemplates = new PayrollDocumentTemplateRepository(this);
    this.properties = new PropertyRepository(this);
    this.proposalAgreements = new ProposalAgreements(this);
    this.proposalEmailTemplates = new ProposalEmailTemplatesRepository(this);
    this.proposalAgreementTemplates = new ProposalAgreementTemplateRepository(
      this
    );
    this.proposalPriceRestrictions = new ProposalPriceRestrictionsRepository(
      this
    );
    this.proposalTemplates = new ProposalTemplateRepository(this);
    this.proposalTemplateDesigns = new ProposalTemplateDesignRepository(this);
    this.purchaseOrders = new PurchaseOrderRepository(this);
    this.physicalCounts = new PhysicalCountRepository(this);
    this.inventoryPurchaseOrders = new InventoryPurchaseOrderRepository(this);
    this.inventoryPurchaseOrderItems =
      new InventoryPurchaseOrderItemsRepository(this);
    this.preferredPaymentMethods = new PreferredPaymentMethodRepository(this);
    this.referralSources = new ReferralSourceRepository(this);
    this.requestTypes = new RequestTypeRepository(this);
    this.resources = new ResourceRepository(this);
    this.resourcePayTypes = new ResourcePayTypeRepository(this);
    this.settings = new SettingsRepository(this);
    this.stageTypes = new StageTypeRepository(this);
    this.standardCrews = new StandardCrewRepository(this);
    this.stockImages = new StockImageRepository(this);
    this.stockorders = new StockOrderRepository(this);
    this.suppliers = new SupplierRepository(this);
    this.summaryReports = new SummaryReportsRepository(this);
    this.taxSchedules = new TaxScheduleRepository(this);
    this.templateCategories = new TemplateCategoryRepository(this);
    this.templates = new TemplateRepository(this);
    this.timerates = new TimeRateRepository(this);
    this.timesheets = new TimesheetRepository(this);
    this.users = new UserRepository(this);
    this.warehouses = new WarehouseRepository(this);
    this.zipCodeTaxSchedules = new ZipCodeTaxSchedulesRepository(this);
    this.linkedJobs = new JobLinkedJobsRepository(this);
    this.depositpercentageoption = new DepositPercentageOptionsRepository(this);
    this.templatePlan = new TemplatePlanRepository(this);
    this.supplyPro = new SPRepository(this);
  }

  delete(url, params, requestHeaders) {
    return this._createXhrRequest("DELETE", url, params, null, requestHeaders);
  }

  get(url, params, requestHeaders, responseOptions) {
    return this._createXhrRequest(
      "GET",
      url,
      params,
      null,
      requestHeaders,
      responseOptions
    );
  }

  graphql(query, variables) {
    return this.post("/graphql", null, {
      query,
      variables,
    });
  }

  patch(url, params, body, requestHeaders) {
    return this._createXhrRequest("PATCH", url, params, body, requestHeaders);
  }

  ping() {
    return this.get("ping");
  }

  post(url, params, body, requestHeaders) {
    return this._createXhrRequest("POST", url, params, body, requestHeaders);
  }

  put(url, params, body, requestHeaders) {
    return this._createXhrRequest("PUT", url, params, body, requestHeaders);
  }

  systemStatus() {
    return this.get("system-status");
  }

  testDateTime(datetime) {
    return this.get("test-datetime", {
      datetime: datetime,
    });
  }

  tokenInfo() {
    return this.get("token-info");
  }

  _createXhrRequest(
    method,
    url,
    params,
    body,
    requestHeaders,
    responseOptions
  ) {
    url = `${this._apiLocation + url}?${JobProAPI.encodeQueryString(params)}`;
    return new Promise((resolve, reject) => {
      // Generate the XHR request
      let req = new XMLHttpRequest();

      // Set expected response type if provided (e.g., 'blob' for PDF)
      if (responseOptions && responseOptions.expectedResponseType) {
        req.responseType = responseOptions.expectedResponseType;
      }

      if (this._useCors) {
        // Check what method of CORS is supported (if any)
        if ("withCredentials" in req) {
          req.withCredentials = true;
          req.open(method, url, true);
        } else if (typeof XDomainRequest !== "undefined") {
          if (
            responseOptions &&
            (responseOptions.expectedResponseType === "blob" ||
              responseOptions.expectedResponseType === "arraybuffer")
          ) {
            reject(
              new Error(
                "CORS with XDomainRequest does not support blob/arraybuffer response types."
              )
            );
            return;
          }
          req = new XDomainRequest();
          req.open(method, url);
        } else {
          throw new Error("CORS is not supported by this browser");
        }
      } else {
        req.open(method, url, true); // Ensure async is true
      }

      const tokenPromise = this._oauthToken || Promise.resolve();
      tokenPromise.then((oauthToken) => {
        // Set OAuth2 token
        if (oauthToken) {
          req.setRequestHeader("Authorization", `Bearer ${oauthToken}`);
        }

        req.onload = () => {
          // Check if call was successful
          if (req.status === 204) {
            //204 is OK but with no content
            resolve();
          } else if (req.status >= 200 && req.status < 300) {
            // Resolve based on responseType
            if (
              req.responseType === "blob" ||
              req.responseType === "arraybuffer"
            ) {
              resolve(req.response); // req.response will be a Blob or ArrayBuffer
            } else if (req.responseType === "json") {
              // If req.responseType was 'json' and browser parsed it
              resolve(req.response);
            } else if (req.responseText !== "") {
              // Default to parsing as JSON if responseText is available and not handled above
              try {
                resolve(JSON.parse(req.responseText));
              } catch (e) {
                const contentType = req.getResponseHeader("Content-Type");
                reject(
                  new APIRequestError(
                    req.responseText,
                    "text", // The raw responseText
                    req.status,
                    `Failed to parse response as JSON. Content-Type: ${contentType}. Error: ${e.message}`
                  )
                );
              }
            } else {
              resolve(); // Empty responseText
            }
          } else {
            // Error handling
            // Assume error responses are typically text or JSON, not blobs.
            let errorResponseText = req.responseText;
            const errorContentType = "text"; // Default for error messages

            if (
              req.responseType === "json" &&
              typeof req.response === "object" &&
              req.response !== null
            ) {
              // If responseType was 'json' and req.response is an object (parsed error by browser)
              try {
                errorResponseText = JSON.stringify(req.response); // APIRequestError expects a string
              } catch (e) {
                errorResponseText =
                  req.statusText || `HTTP error ${req.status}`;
              }
            } else if (
              !errorResponseText &&
              (req.responseType === "blob" ||
                req.responseType === "arraybuffer")
            ) {
              // If responseText is empty for a binary request error
              errorResponseText = `Error ${req.status} for binary request. No further details in responseText.`;
            }
            // Simplifying to pass responseText (or derived error string) to APIRequestError.
            reject(
              new APIRequestError(
                errorResponseText,
                errorContentType,
                req.status,
                req.statusText
              )
            );
          }
        };

        // Handle network errors
        req.onerror = () => {
          reject(Error("Network Error"));
        };

        // Set request headers
        if (
          typeof requestHeaders === "object" &&
          requestHeaders !== null &&
          !Array.isArray(requestHeaders)
        ) {
          // Standard case: headers as an object
          Object.keys(requestHeaders).forEach((k) =>
            req.setRequestHeader(k, requestHeaders[k])
          );
        } else if (typeof requestHeaders === "string") {
          req.setRequestHeader(requestHeaders, "0");
        } else if (Array.isArray(requestHeaders)) {
          requestHeaders.forEach((h) => {
            if (typeof h === "string") {
              req.setRequestHeader(h, "0");
            }
          });
        }

        // Set the request body (for POST, PATCH, etc.)
        if (body) {
          req.setRequestHeader(
            "Content-Type",
            "application/json;charset=UTF-8"
          );
          req.send(JSON.stringify(body));
        } else {
          // Make the request
          req.send();
        }
      });
    });
  }

  static _buildParams(prefix, obj, add) {
    const rbracket = /\[\]$/;
    if (Array.isArray(obj)) {
      // Serialize array
      obj.forEach((item, i) => {
        if (rbracket.test(prefix)) {
          add(prefix, item);
        } else {
          JobProAPI._buildParams(`${prefix}`, item, add);
        }
      });
    } else if (typeof obj === "object") {
      // Serialize object
      for (const name in obj) {
        if (obj.hasOwnProperty(name)) {
          JobProAPI._buildParams(`${prefix}[${name}]`, obj[name], add);
        }
      }
    } else {
      // Serialize scalar
      add(prefix, obj);
    }
  }

  static encodeQueryString(obj) {
    const parts = [];
    const add = function (key, value) {
      value =
        typeof value === "function" ? value() : value == null ? "" : value;
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    };

    if (Array.isArray(obj)) {
      obj.forEach(function () {
        add(this.name, value);
      });
    } else {
      for (const i in obj) {
        if (obj.hasOwnProperty(i)) {
          JobProAPI._buildParams(i, obj[i], add);
        }
      }
    }
    // Join parts with '&' to build the full query string
    return parts.join("&");
  }

  static merge(obj1, obj2) {
    const obj3 = {};
    for (var attrname in obj1) {
      obj3[attrname] = obj1[attrname];
    }
    for (var attrname in obj2) {
      obj3[attrname] = obj2[attrname];
    }
    return obj3;
  }
}

class AttachmentRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/attachments", params);
  }

  create(config, options) {
    return this._api.post("/v1/attachments", options, config);
  }

  delete(id, options) {
    return this._api.delete(`/v1/attachments/${id}`, options);
  }

  get(id, options) {
    return this._api.get(`/v1/attachments/${id}`, options);
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/attachments/${id}`, options, changes);
  }
}

class BidCategoryRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/bidCategories", params);
  }
}

class BidContactRepository {
  constructor(api) {
    this._api = api;
  }

  create(bidId, bidContact, options) {
    return this._api.post(`/v1/bids/${bidId}/contacts`, options, bidContact);
  }

  delete(bidId, bidContactId, options) {
    return this._api.delete(
      `/v1/bids/${bidId}/contacts/${bidContactId}`,
      options
    );
  }

  get(bidId, bidContactId, options) {
    return this._api.get(`/v1/bids/${bidId}/contacts/${bidContactId}`, options);
  }

  query(bidId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/bids/${bidId}/contacts`, params);
  }

  update(bidId, bidContactId, changes, options) {
    return this._api.patch(
      `/v1/bids/${bidId}/contacts/${bidContactId}`,
      options,
      changes
    );
  }
}

class FinanceChargeRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/finance-charges", params);
  }
  getByID(id, options) {
    return this._api.get(`/v1/finance-charges/${id}`, options);
  }
  getByCustomerID(id, options) {
    return this._api.get(`/v1/finance-charges/customer/${id}`, options);
  }
  create(financeCharge, options) {
    return this._api.post("/v1/finance-charges", options, financeCharge);
  }
}

class BidDocumentRepository {
  constructor(api) {
    this._api = api;
  }

  create(bidId, document, options) {
    return this._api.post(`/v1/bids/${bidId}/documents`, options, document);
  }

  get(bidId, documentId, options) {
    return this._api.get(`/v1/bids/${bidId}/documents/${documentId}`, options);
  }

  query(bidId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/bids/${bidId}/documents`, params);
  }
  copyFromTemplate(bidId, templateId) {
    return this._api.post(
      `/v1/bids/${bidId}/documents/copy-from-template/${templateId}`
    );
  }
}

class BidGroupRepository {
  constructor(api) {
    this._api = api;
  }

  create(bidId, bidGroup, options) {
    return this._api.post(`/v1/bids/${bidId}/groups`, options, bidGroup);
  }

  delete(bidId, bidGroupId, options) {
    return this._api.delete(`/v1/bids/${bidId}/groups/${bidGroupId}`, options);
  }

  get(bidId, bidGroupId, options) {
    return this._api.get(`/v1/bids/${bidId}/groups/${bidGroupId}`, options);
  }

  query(bidId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/bids/${bidId}/groups`, params);
  }

  update(bidId, bidGroupId, changes, options) {
    return this._api.patch(
      `/v1/bids/${bidId}/groups/${bidGroupId}`,
      options,
      changes
    );
  }
}

class BidItemImageRepository {
  constructor(api) {
    this._api = api;
  }

  create(bidId, bidItemId, bidItemImage, options) {
    return this._api.post(
      `/v1/bids/${bidId}/items/${bidItemId}/images`,
      options,
      bidItemImage
    );
  }

  delete(bidId, bidItemId, bidItemImageId, options) {
    return this._api.delete(
      `/v1/bids/${bidId}/items/${bidItemId}/images/${bidItemImageId}`,
      options
    );
  }

  get(bidId, bidItemId, bidItemImageId, options) {
    return this._api.get(
      `/v1/bids/${bidId}/items/${bidItemId}/images/${bidItemImageId}`,
      options
    );
  }

  query(bidId, bidItemId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/bids/${bidId}/items/${bidItemId}/images`, params);
  }
}

class BidItemRepository {
  constructor(api) {
    this._api = api;
    this.images = new BidItemImageRepository(api);
  }

  create(bidId, bidItem, options) {
    return this._api.post(`/v1/bids/${bidId}/items`, options, bidItem);
  }

  delete(bidId, bidItemId, options) {
    return this._api.delete(`/v1/bids/${bidId}/items/${bidItemId}`, options);
  }

  get(bidId, bidItemId, options) {
    return this._api.get(`/v1/bids/${bidId}/items/${bidItemId}`, options);
  }

  query(bidId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/bids/${bidId}/items`, params);
  }

  update(bidId, bidItemId, bidItemChanges, options) {
    return this._api.patch(
      `/v1/bids/${bidId}/items/${bidItemId}`,
      options,
      bidItemChanges
    );
  }
}

class BidOptionRepository {
  constructor(api) {
    this._api = api;
  }

  create(bidId, bidOption, options) {
    return this._api.post(`/v1/bids/${bidId}/options`, options, bidOption);
  }

  delete(bidId, bidOptionId, options) {
    return this._api.delete(
      `/v1/bids/${bidId}/options/${bidOptionId}`,
      options
    );
  }

  get(bidId, bidOptionId, options) {
    return this._api.get(`/v1/bids/${bidId}/options/${bidOptionId}`, options);
  }

  query(bidId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/bids/${bidId}/options`, params);
  }

  update(bidId, bidOptionId, changes, options) {
    return this._api.patch(
      `/v1/bids/${bidId}/options/${bidOptionId}`,
      options,
      changes
    );
  }
}
class RValueRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/rvalues", params);
  }
  get(id, options) {
    return this._api.get(`/v1/rvalues/rvaluethickness/${id}`, options);
  }
}
class BidItemMultipliersRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/biditemmultipliers", params);
  }
  get(id, options) {
    return this._api.get(`/v1/biditemmultipliers/${id}`, options);
  }
  getEntries(id, options) {
    return this._api.get(`/v1/biditemmultipliers/${id}/entries`, options);
  }
  create(bidItemMultipliersReference, options) {
    return this._api.post(
      "/v1/biditemmultipliers",
      bidItemMultipliersReference,
      options
    );
  }

  update(id, bidItemMultipliersReference, options) {
    return this._api.patch(
      `/v1/biditemmultipliers/${id}`,
      bidItemMultipliersReference,
      options
    );
  }

  delete(id) {
    return this._api.delete(`/v1/biditemmultipliers/${id}`);
  }

  updateEntry(id, changes, options) {
    return this._api.patch(
      `/v1/biditemmultipliers/entry/${id}`,
      changes,
      options
    );
  }
  createEntry(bidItemMultipliersReferenceId, entry, options) {
    return this._api.post(
      `/v1/biditemmultipliers/${bidItemMultipliersReferenceId}/entry`,
      entry,
      options
    );
  }
  deleteEntry(bidItemMultipliersReferenceId, entryId) {
    return this._api.delete(
      `/v1/biditemmultipliers/${bidItemMultipliersReferenceId}/entry/${entryId}`
    );
  }
}

class BidRepository {
  constructor(api) {
    this._api = api;
    this.adjustmentHistory = new BidAdjustmentHistoryRepository(api);
    this.checklistItems = new BidChecklistItemsRepository(api);
    this.contacts = new BidContactRepository(api);
    this.documents = new BidDocumentRepository(api);
    this.groups = new BidGroupRepository(api);
    this.items = new BidItemRepository(api);
    this.notes = new BidNoteRepository(api);
    this.options = new BidOptionRepository(api);
    this.statuses = new BidStatusRepository(api);
  }

  create(bid, options) {
    return this._api.post("/v1/bids", options, bid);
  }
  searchByName(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/bids/searchb", params);
  }

  get(id, options) {
    return this._api.get(`/v1/bids/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/bids", params);
  }

  update(bidId, bid, options) {
    return this._api.patch(`/v1/bids/${bidId}`, options, bid);
  }

  getByCustomerID(customerID, options) {
    return this._api.get(`/v1/bids/customer/${customerID}`, options);
  }
  getOtherChangeOrders(id, options) {
    return this._api.get(`/v1/bids/${id}/getchangeorders`, options);
  }
  createChangeOrder(jobid, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.post(`/v1/bids/${jobid}/createchangeorder`, params);
  }
}

class BidAdjustmentHistoryRepository {
  constructor(api) {
    this._api = api;
  }

  get(bidId, bidAdjustmentHistoryId, options) {
    return this._api.get(
      `/v1/bids/${bidId}/adjustment-history/${bidAdjustmentHistoryId}`,
      options
    );
  }

  query(bidId, options) {
    return this._api.get(`/v1/bids/${bidId}/adjustment-history`, options);
  }

  create(bidId, bidAdjustmentHistory, options) {
    return this._api.post(
      `/v1/bids/${bidId}/adjustment-history`,
      options,
      bidAdjustmentHistory
    );
  }
}

class BidChecklistItemsRepository {
  constructor(api) {
    this._api = api;
  }

  create(bidId, bidChecklistItem, options) {
    return this._api.post(
      `/v1/bids/${bidId}/checklistItems`,
      options,
      bidChecklistItem
    );
  }

  delete(bidId, bidChecklistItemId, options) {
    return this._api.delete(
      `/v1/bids/${bidId}/checklistItems/${bidChecklistItemId}`,
      options
    );
  }

  get(bidId, bidChecklistItemId, options) {
    return this._api.get(
      `/v1/bids/${bidId}/checklistItems/${bidChecklistItemId}`,
      options
    );
  }

  query(bidId, criteria, bidChecklistItems) {
    const params = JobProAPI.merge(criteria, bidChecklistItems);
    return this._api.get(`/v1/bids/${bidId}/checklistItems`, params);
  }

  update(bidId, bidChecklistItemId, changes, options) {
    return this._api.patch(
      `/v1/bids/${bidId}/checklistItems/${bidChecklistItemId}`,
      options,
      changes
    );
  }
}

class BidNoteRepository {
  constructor(api) {
    this._api = api;
  }

  create(bidId, note, options) {
    return this._api.post(`/v1/bids/${bidId}/notes`, options, note);
  }
}

class BidStatusRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/bids/statuses", params);
  }
}

class BidTypeRepository {
  constructor(api) {
    this._api = api;
  }

  create(jobType, options) {
    return this._api.post("/v1/bidTypes", options, jobType);
  }

  delete(id, options) {
    return this._api.delete(`/v1/bidTypes/${id}`, options);
  }

  get(id, options) {
    return this._api.get(`/v1/bidTypes/${id}`, options);
  }

  query(criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get("/v1/bidTypes", params);
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/bidTypes/${id}`, options, changes);
  }
}

class CalendarRepository {
  constructor(api) {
    this._api = api;
  }

  create(calendarEvent, options) {
    return this._api.post("/v1/calendar", options, calendarEvent);
  }

  currentUser(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/calendar/current-user`, params);
  }

  delete(calendarEventId, options) {
    return this._api.delete(`/v1/calendar/${calendarEventId}`, options);
  }

  get(calendarEventId, options) {
    return this._api.get(`/v1/calendar/${calendarEventId}`, options);
  }

  put(calendarEventId, calendarEvent, options) {
    return this._api.put(
      `/v1/calendar/${calendarEventId}`,
      options,
      calendarEvent
    );
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/calendar", params);
  }

  search(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/calendar/search", params);
  }

  update(calendarEventId, calendarEvent, options) {
    return this._api.patch(
      `/v1/calendar/${calendarEventId}`,
      options,
      calendarEvent
    );
  }

  split(calendarEventId, options) {
    return this._api.patch(`/v1/calendar/split/${calendarEventId}`, options);
  }

  createSplitEvents(calendarEvent, options) {
    return this._api.post("/v1/calendar/split", options, calendarEvent);
  }

  dailyScheduleReport(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/calendar/daily-schedule-report", params);
  }
}

class CalendarPeriodsRepository {
  constructor(api) {
    this._api = api;
  }

  create(calendarPeriod, options) {
    return this._api.post("/v1/calendarperiods", options, calendarPeriod);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/calendarperiods/search", params);
  }

  calendarperiodinfo(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/calendarperiods/calendarperiodinfo`, params);
  }

  update(calendarPeriodId, changes, options) {
    return this._api.patch(
      `/v1/calendarperiods/${calendarPeriodId}`,
      options,
      changes
    );
  }

  close(calendarPeriodId, changes, options) {
    return this._api.patch(
      `/v1/calendarperiods/close/${calendarPeriodId}`,
      options,
      changes
    );
  }

  delete(id, options) {
    return this._api.delete(`/v1/calendarperiods/${id}`, options);
  }

  report(id, options) {
    return this._api.get(`/v1/calendarperiods/report/${id}`, options);
  }
  isValidTransactionDate(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/calendarperiods/isvalidtransactiondate`, params);
  }
}

class ChecklistDefinitionRepository {
  constructor(api) {
    this._api = api;
  }

  get(checklistDefinitionId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(
      `/v1/checklist-definitions/${checklistDefinitionId}`,
      params
    );
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/checklist-definitions", params);
  }
}

class CommissionPlanRepository {
  constructor(api) {
    this._api = api;
    this.rules = new CommissionPlanRuleRepository(api);
  }

  create(commissionPlan, options) {
    return this._api.post("/v1/commissionPlans", options, commissionPlan);
  }

  delete(id, options) {
    return this._api.delete(`/v1/commissionPlans/${id}`, options);
  }

  get(id, options) {
    return this._api.get(`/v1/commissionPlans/${id}`, options);
  }

  query(criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get("/v1/commissionPlans", params);
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/commissionPlans/${id}`, options, changes);
  }
}

class CommissionPlanRuleRepository {
  constructor(api) {
    this._api = api;
  }

  create(commissionPlanId, commissionPlan, options) {
    return this._api.post(
      `/v1/commissionPlans/${commissionPlanId}/rules`,
      options,
      commissionPlan
    );
  }

  delete(commissionPlanId, commissionPlanRuleId, options) {
    return this._api.delete(
      `/v1/commissionPlans/${commissionPlanId}/rules/${commissionPlanRuleId}`,
      options
    );
  }

  get(commissionPlanId, commissionPlanRuleId, options) {
    return this._api.get(
      `/v1/commissionPlans/${commissionPlanId}/rules/${commissionPlanRuleId}`,
      options
    );
  }

  query(commissionPlanId, criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get(
      `/v1/commissionPlans/${commissionPlanId}/rules`,
      params
    );
  }

  update(commissionPlanId, commissionPlanRuleId, changes, options) {
    return this._api.patch(
      `/v1/commissionPlans/${commissionPlanId}/rules/${commissionPlanRuleId}`,
      options,
      changes
    );
  }
}

class CommissionRateRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/commission-rates", params);
  }
}

class CompanyNetTermRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/companyNetTerms", params);
  }
}

class CompanyTaxStatusRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/companyTaxStatuses", params);
  }
}

class ContactRepository {
  constructor(api) {
    this._api = api;
  }

  create(contact, options) {
    return this._api.post("/v1/contacts", options, contact);
  }

  get(id, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/contacts/${id}`, params);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/contacts", params);
  }

  search(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/contacts/search", params);
  }

  update(contactId, changes, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.patch(`/v1/contacts/${contactId}`, params, changes);
  }

  delete(contactId, options) {
    return this._api.delete(`/v1/contacts/${contactId}`, options);
  }
}

class CountryRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/countries", params);
  }
}

class CurrentUserOrganizationRepository {
  constructor(api) {
    this._api = api;
    this.settings = new CurrentUserOrganizationSettingsRepository(api);
  }

  get(options) {
    return this._api.get("/v1/user/organization", options);
  }

  update(changes, options) {
    return this._api.patch("/v1/user/organization", options, changes);
  }
}

class CurrentUserOrganizationSettingsRepository {
  constructor(api) {
    this._api = api;
  }

  get(options) {
    return this._api.get("/v1/user/organization/settings", options);
  }

  update(changes, options) {
    return this._api.patch("/v1/user/organization/settings", options, changes);
  }
}

class CurrentUserRepository {
  constructor(api) {
    this._api = api;
    this.organization = new CurrentUserOrganizationRepository(api);
    this.settings = new CurrentUserSettingsRepository(api);
  }
}

class CurrentUserSettingsRepository {
  constructor(api) {
    this._api = api;
  }

  get(options) {
    return this._api.get("/v1/user/settings", options);
  }
}

class CustomerRepository {
  constructor(api) {
    this._api = api;
    this.contacts = new CustomerContactRepository(api);
    this.documents = new CustomerDocumentRepository(api);
  }

  create(customer, options) {
    return this._api.post("/v1/customers", options, customer);
  }

  count(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/customers/count", params);
  }

  get(id, options) {
    return this._api.get(`/v1/customers/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/customers", params);
  }

  search(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/customers/search", params);
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/customers/${id}`, options, changes);
  }
}

class CustomerDocumentRepository {
  constructor(api) {
    this._api = api;
  }

  create(customerId, document, options) {
    return this._api.post(
      `/v1/customers/${customerId}/documents`,
      options,
      document
    );
  }

  get(customerId, documentId, options) {
    return this._api.get(
      `/v1/customers/${customerId}/documents/${documentId}`,
      options
    );
  }

  query(customerId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/customers/${customerId}/documents`, params);
  }

  delete(customerId, documentId, options) {
    return this._api.delete(
      `/v1/customers/${customerId}/documents/${documentId}`,
      options
    );
  }

  update(customerId, documentId, changes, options) {
    return this._api.patch(
      `/v1/customers/${customerId}/documents/${documentId}`,
      options,
      changes
    );
  }
}

class CustomerCategoryRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/customerCategories", params);
  }
}

class CustomerContactRepository {
  constructor(api) {
    this._api = api;
  }

  create(customerId, contact, options) {
    return this._api.post(
      `/v1/customers/${customerId}/contacts`,
      options,
      contact
    );
  }

  get(customerId, contactId, options) {
    return this._api.get(
      `/v1/customers/${customerId}/contacts/${contactId}`,
      options
    );
  }

  query(customerId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/customers/${customerId}/contacts`, params);
  }
}

class CustomerDocumentTemplateRepository {
  constructor(api) {
    this._api = api;
  }

  delete(id, options) {
    return this._api.delete(`/v1/customerDocumentTemplates/${id}`, options);
  }

  get(id, options) {
    return this._api.get(`/v1/customerDocumentTemplates/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/customerDocumentTemplates", params);
  }

  update(id, changes, options) {
    return this._api.patch(
      `/v1/customerDocumentTemplates/${id}`,
      options,
      changes
    );
  }
}

class CustomerStatusRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/customerStatuses", params);
  }
}

class DataSheetRepository {
  constructor(api) {
    this._api = api;
    this.notes = new DataSheetNoteRepository(api);
    this.documents = new DataSheetDocumentRepository(api);
    this.requestQuestionResponses =
      new DataSheetRequestQuestionResponseRepository(api);
    this.statuses = new DataSheetStatusRepository(api);
  }

  create(datasheet, options) {
    return this._api.post("/v1/datasheets", options, datasheet);
  }

  get(id, options) {
    return this._api.get(`/v1/datasheets/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/datasheets", params);
  }

  search(criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get("/v1/datasheets/search", params);
  }

  update(datasheetId, datasheet, options) {
    return this._api.patch(`/v1/datasheets/${datasheetId}`, options, datasheet);
  }
}

class DataSheetDocumentRepository {
  constructor(api) {
    this._api = api;
  }

  get(datasheetId, documentId, options) {
    return this._api.get(
      `/v1/datasheet/${datasheetId}/documents/${documentId}`,
      options
    );
  }
}

class DataSheetNoteRepository {
  constructor(api) {
    this._api = api;
  }

  create(datasheetId, note, options) {
    return this._api.post(`/v1/datasheets/${datasheetId}/notes`, options, note);
  }
}

class DataSheetRequestQuestionResponseRepository {
  constructor(api) {
    this._api = api;
  }

  get(dataSheetId, requestQuestionResponseId, options) {
    return this._api.get(
      `/v1/datasheets/${dataSheetId}/requestQuestionResponses/${requestQuestionResponseId}`,
      options
    );
  }

  query(dataSheetId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(
      `/v1/datasheets/${dataSheetId}/requestQuestionResponses`,
      params
    );
  }

  update(dataSheetId, requestQuestionResponseId, response, options) {
    return this._api.patch(
      `/v1/datasheets/${dataSheetId}/requestQuestionResponses/${requestQuestionResponseId}`,
      options,
      response
    );
  }
}

class DataSheetStatusRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/datasheets/statuses", params);
  }
}

class EmployeeRepository {
  constructor(api) {
    this._api = api;
    this.calendar = new EmployeeCalendarRepository(api);
    this.commissionPlans = new EmployeeCommissionPlanRepository(api);
    this.documents = new EmployeeDocumentRepository(api);
    this.offices = new EmployeeOfficeRepository(api);
    this.payments = new EmployeePaymentRepository(api);
    this.recurringPayments = new EmployeeRecurringPaymentRepository(api);
    this.timeRates = new EmployeeTimeRateRepository(api);
  }

  create(employee, options) {
    return this._api.post("/v1/employees", options, employee);
  }

  get(id, options) {
    return this._api.get(`/v1/employees/${id}`, options);
  }

  query(criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get("/v1/employees", params);
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/employees/${id}`, options, changes);
  }
}

class EmployeeCalendarRepository {
  constructor(api) {
    this._api = api;
  }

  query(employeeId, criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get(`/v1/employees/${employeeId}/calendar`, params);
  }
}

class EmployeeCommissionPlanRepository {
  constructor(api) {
    this._api = api;
  }

  create(employeeId, employeeCommissionPlan, options) {
    return this._api.post(
      `/v1/employees/${employeeId}/commissionPlans`,
      options,
      employeeCommissionPlan
    );
  }

  delete(employeeId, employeeCommissionPlanId, options) {
    return this._api.delete(
      `/v1/employees/${employeeId}/commissionPlans/${employeeCommissionPlanId}`,
      options
    );
  }

  get(employeeId, employeeCommissionPlanId, options) {
    return this._api.get(
      `/v1/employees/${employeeId}/commissionPlans/${employeeCommissionPlanId}`,
      options
    );
  }

  query(employeeId, criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get(`/v1/employees/${employeeId}/commissionPlans`, params);
  }

  update(employeeId, employeeCommissionPlanId, changes, options) {
    return this._api.patch(
      `/v1/employees/${employeeId}/commissionPlans/${employeeCommissionPlanId}`,
      options,
      changes
    );
  }
}

class EmployeeDocumentRepository {
  constructor(api) {
    this._api = api;
  }

  create(employeeId, document, options) {
    return this._api.post(
      `/v1/employees/${employeeId}/documents`,
      options,
      document
    );
  }

  delete(employeeId, documentId, options) {
    return this._api.delete(
      `/v1/employees/${employeeId}/documents/${documentId}`,
      options
    );
  }

  get(employeeId, documentId, options) {
    return this._api.get(
      `/v1/employees/${employeeId}/documents/${documentId}`,
      options
    );
  }

  query(employeeId, criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get(`/v1/employees/${employeeId}/documents`, params);
  }

  update(employeeId, documentId, changes, options) {
    return this._api.patch(
      `/v1/employees/${employeeId}/documents/${documentId}`,
      options,
      changes
    );
  }
}

class EmployeeOfficeRepository {
  constructor(api) {
    this._api = api;
  }

  create(employeeId, office, options) {
    return this._api.post(
      `/v1/employees/${employeeId}/offices`,
      options,
      office
    );
  }

  delete(employeeId, officeId, options) {
    return this._api.delete(
      `/v1/employees/${employeeId}/offices/${officeId}`,
      options
    );
  }

  query(criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get("/v1/employees", params);
  }
}

class EmployeePaymentRepository {
  constructor(api) {
    this._api = api;
  }

  create(employeeId, payment, options) {
    return this._api.post(
      `/v1/employees/${employeeId}/payments`,
      options,
      payment
    );
  }

  delete(employeeId, paymentId, options) {
    return this._api.delete(
      `/v1/employees/${employeeId}/payments/${paymentId}`,
      options
    );
  }

  get(employeeId, paymentId, options) {
    return this._api.get(
      `/v1/employees/${employeeId}/payments/${paymentId}`,
      options
    );
  }

  query(employeeId, criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get(`/v1/employees/${employeeId}/payments`, params);
  }

  update(employeeId, paymentId, changes, options) {
    return this._api.patch(
      `/v1/employees/${employeeId}/payments/${paymentId}`,
      options,
      changes
    );
  }
}

class EmployeeRecurringPaymentRepository {
  constructor(api) {
    this._api = api;
  }

  create(employeeId, recurringPayment, options) {
    return this._api.post(
      `/v1/employees/${employeeId}/recurringPayments`,
      options,
      recurringPayment
    );
  }

  delete(employeeId, recurringPaymentId, options) {
    return this._api.delete(
      `/v1/employees/${employeeId}/recurringPayments/${recurringPaymentId}`,
      options
    );
  }

  get(employeeId, recurringPaymentId, options) {
    return this._api.get(
      `/v1/employees/${employeeId}/recurringPayments/${recurringPaymentId}`,
      options
    );
  }

  query(employeeId, criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get(
      `/v1/employees/${employeeId}/recurringPayments`,
      params
    );
  }

  update(employeeId, recurringPaymentId, changes, options) {
    return this._api.patch(
      `/v1/employees/${employeeId}/recurringPayments/${recurringPaymentId}`,
      options,
      changes
    );
  }
}

class EmployeeTimeRateRepository {
  constructor(api) {
    this._api = api;
  }

  query(employeeId, criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get(`/v1/employees/${employeeId}/timeRates`, params);
  }

  put(employeeId, timeRate, options) {
    return this._api.put(
      `/v1/employees/${employeeId}/timeRates`,
      options,
      timeRate
    );
  }
}

class EquipmentRepository {
  constructor(api) {
    this._api = api;
    this.documents = new EquipmentDocumentRepository(api);
    this.notes = new EquipmentNoteRepository(api);
  }
  create(equipment, options) {
    return this._api.post("/v1/equipment", options, equipment);
  }

  get(id, options) {
    return this._api.get(`/v1/equipment/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/equipment", params);
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/equipment/${id}`, options, changes);
  }
}

class DepositPercentageOptionsRepository {
  constructor(api) {
    this._api = api;
  }
  create(depositpercentageoption, options) {
    return this._api.post(
      "/v1/depositpercentageoptions",
      options,
      depositpercentageoption
    );
  }

  get(id, options) {
    return this._api.get(`/v1/depositpercentageoptions/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/depositpercentageoptions", params);
  }

  update(id, changes, options) {
    return this._api.patch(
      `/v1/depositpercentageoptions/${id}`,
      options,
      changes
    );
  }
}

class BidDepositOptionRepository {
  constructor(api) {
    this._api = api;
  }
  create(depositpercentageoption, options) {
    return this._api.post(
      "/v1/depositpercentageoptions",
      options,
      depositpercentageoption
    );
  }

  get(id, options) {
    return this._api.get(`/v1/depositpercentageoptions/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/depositpercentageoptions", params);
  }

  update(id, changes, options) {
    return this._api.patch(
      `/v1/depositpercentageoptions/${id}`,
      options,
      changes
    );
  }
}

class EquipmentDocumentRepository {
  constructor(api) {
    this._api = api;
  }

  create(equipmentId, document, options) {
    return this._api.post(
      `/v1/equipment/${equipmentId}/documents`,
      options,
      document
    );
  }

  delete(equipmentId, documentId, options) {
    return this._api.delete(
      `/v1/equipment/${equipmentId}/documents/${documentId}`,
      options
    );
  }

  get(equipmentId, documentId, options) {
    return this._api.get(
      `/v1/equipment/${equipmentId}/documents/${documentId}`,
      options
    );
  }

  query(equipmentId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/equipment/${equipmentId}/documents`, params);
  }
}

class EquipmentNoteRepository {
  constructor(api) {
    this._api = api;
  }

  create(equipmentId, note, options) {
    return this._api.post(`/v1/equipment/${equipmentId}/notes`, options, note);
  }

  delete(equipmentId, noteId, options) {
    return this._api.delete(
      `/v1/equipment/${equipmentId}/notes/${noteId}`,
      options
    );
  }

  get(equipmentId, noteId, options) {
    return this._api.get(
      `/v1/equipment/${equipmentId}/notes/${noteId}`,
      options
    );
  }

  query(equipmentId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/equipment/${equipmentId}/notes`, params);
  }

  update(equipmentId, noteId, changes, options) {
    return this._api.patch(
      `/v1/equipment/${equipmentId}/notes/${noteId}`,
      options,
      changes
    );
  }
}

class EquipmentStatusRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/equipmentStatuses", params);
  }
}

class EquipmentTypesRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/equipmentTypes", params);
  }
}

class FinanceProgramRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/finance-programs", params);
  }
}

class GlobalLaborCodeRepository {
  constructor(api) {
    this._api = api;
  }

  create(invoice, options) {
    return this._api.post("/v1/globalLaborCodes", options, invoice);
  }

  get(id, options) {
    return this._api.get(`/v1/globalLaborCodes/${id}`, options);
  }

  query(criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get("/v1/globalLaborCodes", params);
  }
}

class InventoryRepository {
  constructor(api) {
    this._api = api;
  }

  search(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/inventory/search", params);
  }

  items(itemid, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/inventory/items/${itemid}`, params);
  }

  valueForQuickBooks(criteria, options) {
    return this._api.get("/v1/inventory/valueForQuickBooks");
  }

  getAlternatesByItem(itemId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/inventory/alternates/${itemId}`, params);
  }

  searchAlternatesByItem(itemId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/inventory/alternates/search/${itemId}`, params);
  }

  getRigs(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/inventory/rigs", params);
  }

  getRigsList(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/inventory/getRigs", params);
  }

  getRigsById(rigId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/inventory/rigs/${rigId}`, params);
  }

  getRigsByIdNoAlt(rigId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/inventory/rigs/noAlt/${rigId}`, params);
  }

  getSerializedInventory(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/inventory/serializedInventory", params);
  }

  getRecentJobsByItem(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/inventory/recentJobsByItem", params);
  }

  transferItems(options) {
    return this._api.post("/v1/inventory/transferitems", options);
  }

  transferFoam(options) {
    return this._api.post("/v1/inventory/transferfoam", options);
  }

  adjustItemQty(options) {
    return this._api.post("/v1/inventory/adjustitemqty", options);
  }

  transferInventoryAmtFromTruckToJobWIP(options) {
    return this._api.post(
      "/v1/inventory/transferinventoryamtfromtruckTojobwip",
      options
    );
  }

  wipInventoryByJob(jobId, options) {
    return this._api.get(`/v1/inventory/wip/${jobId}`, options);
  }
  getCurrentValueReport(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(
      "/v1/inventory/current-inventory-value-report",
      params
    );
  }

  searchInventory(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/inventory/inventorysearch", params);
  }
  searchInventorySerialized(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/inventory/inventorysearchserialized", params);
  }
  transferInventory(transferStr) {
    return this._api.post("/v1/inventory/transferinventory", transferStr);
  }
  adjustInventory(adjustmentStr) {
    return this._api.post("/v1/inventory/adjustinventory", adjustmentStr);
  }
  getInventoryItemDetail(itemId, warehouseId, options) {
    const params = JobProAPI.merge(
      { itemId: itemId, warehouseId: warehouseId },
      options
    );
    return this._api.get(`/v1/inventory/inventoryitemdetail`, params);
  }
}

class InventoryTransactionRepository {
  constructor(api) {
    this._api = api;
  }

  create(purchaseOrder, options) {
    return this._api.post("/v1/inv_transactions", options, purchaseOrder);
  }

  delete(id, options) {
    return this._api.delete(`/v1/inv_transactions/${id}`, options);
  }

  get(id, options) {
    return this._api.get(`/v1/inv_transactions/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/inv_transactions", params);
  }

  search(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/inv_transactions/search", params);
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/inv_transactions/${id}`, options, changes);
  }
}

class InvoiceRepository {
  constructor(api) {
    this._api = api;
    this.creditMemos = new InvoiceCreditMemoRepository(api);
    this.items = new InvoiceItemRepository(api);
    this.paidInvoices = new InvoicePaidInvoiceRepository(api);
    this.payments = new InvoicePaymentRepository(api);
    this.statuses = new InvoiceStatusRepository(api);
  }

  count(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/invoices/count", params);
  }

  create(invoice, options) {
    return this._api.post("/v1/invoices", options, invoice);
  }

  delete(id, options) {
    return this._api.delete(`/v1/invoices/${id}`, options);
  }

  get(id, options) {
    return this._api.get(`/v1/invoices/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/invoices", params);
  }

  update(id, invoice, options) {
    return this._api.patch(`/v1/invoices/${id}`, options, invoice);
  }

  search(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/invoices/search", params);
  }
}

class InvoiceCreditMemoRepository {
  constructor(api) {
    this._api = api;
  }

  put(invoiceId, creditMemos, options) {
    return this._api.put(
      `/v1/invoices/${invoiceId}/creditMemos`,
      options,
      creditMemos
    );
  }
}

class InvoiceItemRepository {
  constructor(api) {
    this._api = api;
  }

  create(invoiceId, invoiceItem, options) {
    return this._api.post(
      `/v1/invoices/${invoiceId}/items`,
      options,
      invoiceItem
    );
  }

  get(invoiceId, invoiceItemId, options) {
    return this._api.get(
      `/v1/invoices/${invoiceId}/items/${invoiceItemId}`,
      options
    );
  }

  query(invoiceId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/invoices/${invoiceId}/items`, params);
  }

  update(invoiceId, invoiceItemId, invoiceItem, options) {
    return this._api.patch(
      `/v1/invoices/${invoiceId}/items/${invoiceItemId}`,
      options,
      invoiceItem
    );
  }
}

class InvoicePaidInvoiceRepository {
  constructor(api) {
    this._api = api;
  }

  put(invoiceId, paidInvoices, options) {
    return this._api.put(
      `/v1/invoices/${invoiceId}/paidInvoices`,
      options,
      paidInvoices
    );
  }
}

class InvoicePaymentRepository {
  constructor(api) {
    this._api = api;
  }

  query(invoiceId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/invoices/${invoiceId}/payments`, params);
  }
}

class InvoiceStatusRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/invoices/statuses", params);
  }
}

class InvoiceTemplateRepository {
  constructor(api) {
    this._api = api;
  }

  delete(id, options) {
    return this._api.delete(`/v1/invoiceTemplates/${id}`, options);
  }

  get(id, options) {
    return this._api.get(`/v1/invoiceTemplates/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/invoiceTemplates", params);
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/invoiceTemplates/${id}`, options, changes);
  }
}

class ItemRepository {
  constructor(api) {
    this._api = api;
    this.categories = new ItemCategoryRepository(api);
    this.offices = new ItemOfficeRepository(api);
    this.pricing = new ItemPricingRepository(api);
    this.types = new ItemTypeRepository(api);
    this.manufacturers = new ItemManufacturerRepository(api);
  }

  count(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/items/count", params);
  }

  children(id, options) {
    return this._api.get(`/v1/items/${id}/childItems`, options);
  }
  create(item, options) {
    return this._api.post("/v1/items", options, item);
  }

  defaultBin(id, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/items/${id}/defaultBin`, params);
  }

  get(id, options) {
    return this._api.get(`/v1/items/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/items", params);
  }

  search(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/items/search", params);
  }

  searchCount(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/items/search/count", params);
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/items/${id}`, options, changes);
  }

  allocations(itemid, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/items/${itemid}/allocations`, params);
  }

  alternates(itemid, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/items/${itemid}/alternates`, params);
  }

  stockorders(itemid, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/items/${itemid}/stockorders`, params);
  }
}

class ItemManufacturerRepository {
  constructor(api) {
    this._api = api;
  }

  create(manufacturer, options) {
    return this._api.post("/v1/items/manufacturers", options, manufacturer);
  }

  get(id, options) {
    return this._api.get(`/v1/items/manufacturers/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/items/manufacturers", params);
  }

  update(id, manufacturer, options) {
    return this._api.patch(
      `/v1/items/manufacturers/${id}`,
      options,
      manufacturer
    );
  }
}

class ItemCategoryRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/items/categories", params);
  }
}

class ItemOfficeRepository {
  constructor(api) {
    this._api = api;
  }

  create(itemId, itemOffice, options) {
    return this._api.post(`/v1/items/${itemId}/offices`, options, itemOffice);
  }

  delete(itemId, officeId, options) {
    return this._api.delete(`/v1/items/${itemId}/offices/${officeId}`, options);
  }

  query(itemId, criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get(`/v1/items/${itemId}/offices`, params);
  }

  update(itemId, officeId, changes, options) {
    return this._api.patch(
      `/v1/items/${itemId}/offices/${officeId}`,
      options,
      changes
    );
  }
}

class ItemPricingRepository {
  constructor(api) {
    this._api = api;
  }

  create(itemId, itemPricing, options) {
    return this._api.post(`/v1/items/${itemId}/pricing`, options, itemPricing);
  }

  delete(itemId, pricingId, options) {
    return this._api.delete(
      `/v1/items/${itemId}/pricing/${pricingId}`,
      options
    );
  }

  query(itemId, criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get(`/v1/items/${itemId}/pricing`, params);
  }

  update(itemId, pricingId, changes, options) {
    return this._api.patch(
      `/v1/items/${itemId}/pricing/${pricingId}`,
      options,
      changes
    );
  }
}

class ItemTypeRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/items/types", params);
  }
}

class JobCalendarRepository {
  constructor(api) {
    this._api = api;
  }

  create(jobId, calendarEvent, options) {
    return this._api.post(`/v1/jobs/${jobId}/calendar`, options, calendarEvent);
  }

  query(jobId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/jobs/${jobId}/calendar`, params);
  }
}

class JobChecklistRepository {
  constructor(api) {
    this._api = api;
  }

  create(jobId, jobChecklist, options) {
    const { requestId, ...params } = options || {};
    return this._api.post(
      `/v1/jobs/${jobId}/checklists`,
      options,
      jobChecklist,
      {
        "Request-ID": requestId,
      }
    );
  }

  delete(jobId, jobChecklistId, options) {
    return this._api.delete(
      `/v1/jobs/${jobId}/checklists/${jobChecklistId}`,
      options
    );
  }

  get(jobId, jobChecklistId, options) {
    return this._api.get(
      `/v1/jobs/${jobId}/checklists/${jobChecklistId}`,
      options
    );
  }

  update(jobId, jobChecklistId, checklist, options) {
    return this._api.patch(
      `/v1/jobs/${jobId}/checklists/${jobChecklistId}`,
      options,
      checklist
    );
  }
}

class JobCrewsRepository {
  constructor(api) {
    this._api = api;
  }

  create(jobId, crew, options) {
    return this._api.post(`/v1/jobs/${jobId}/crews`, options, crew);
  }

  delete(jobId, crewId, options) {
    return this._api.delete(`/v1/jobs/${jobId}/crews/${crewId}`, options);
  }

  get(jobId, crewId, options) {
    return this._api.get(`/v1/jobs/${jobId}/crews/${crewId}`, options);
  }

  put(jobId, crewId, crew, options) {
    return this._api.put(`/v1/jobs/${jobId}/crews/${crewId}`, options, crew);
  }

  query(jobId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/jobs/${jobId}/crews`, params);
  }
}

class JobDocumentRepository {
  constructor(api) {
    this._api = api;
  }

  create(jobId, document, options) {
    const { requestId, ...params } = options || {};
    return this._api.post(`/v1/jobs/${jobId}/documents`, options, document, {
      "Request-ID": requestId,
    });
  }

  get(jobId, documentId, options) {
    return this._api.get(`/v1/jobs/${jobId}/documents/${documentId}`, options);
  }

  query(jobId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/jobs/${jobId}/documents`, params);
  }
}

class JobDocumentTemplateRepository {
  constructor(api) {
    this._api = api;
  }

  delete(id, options) {
    return this._api.delete(`/v1/jobDocumentTemplates/${id}`, options);
  }

  get(id, options) {
    return this._api.get(`/v1/jobDocumentTemplates/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/jobDocumentTemplates", params);
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/jobDocumentTemplates/${id}`, options, changes);
  }
}

class JobExpenseRepository {
  constructor(api) {
    this._api = api;
  }

  create(jobId, expense, options) {
    const { requestId, ...params } = options || {};
    return this._api.post(`/v1/jobs/${jobId}/expenses`, options, expense, {
      "Request-ID": requestId,
    });
  }

  delete(jobId, expenseId, options) {
    return this._api.delete(`/v1/jobs/${jobId}/expenses/${expenseId}`, options);
  }

  get(jobId, expenseId, options) {
    return this._api.get(`/v1/jobs/${jobId}/expenses/${expenseId}`, options);
  }

  query(jobId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/jobs/${jobId}/expenses`, params);
  }
}

class JobInvoicesRepository {
  constructor(api) {
    this._api = api;
  }

  query(jobId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/jobs/${jobId}/invoices`, params);
  }
}

class JobItemRepository {
  constructor(api) {
    this._api = api;
  }

  create(jobId, jobItem, options) {
    const { requestId, ...params } = options || {};
    return this._api.post(`/v1/jobs/${jobId}/items`, options, jobItem, {
      "Request-ID": requestId,
    });
  }

  delete(jobId, jobItemId, options) {
    return this._api.delete(`/v1/jobs/${jobId}/items/${jobItemId}`, options);
  }

  get(jobId, jobItemId, options) {
    return this._api.get(`/v1/jobs/${jobId}/items/${jobItemId}`, options);
  }

  query(jobId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/jobs/${jobId}/items`, params);
  }

  split(jobId, jobItemId, jobItem, options) {
    return this._api.post(
      `/v1/jobs/${jobId}/items/${jobItemId}/split`,
      options,
      jobItem
    );
  }

  update(jobId, jobItemId, jobItem, options) {
    return this._api.patch(
      `/v1/jobs/${jobId}/items/${jobItemId}`,
      options,
      jobItem
    );
  }
}

class JobRepository {
  constructor(api) {
    this._api = api;
    this.calendar = new JobCalendarRepository(api);
    this.changeOrders = new JobChangeOrdersRepository(api);
    this.checklists = new JobChecklistRepository(api);
    this.crews = new JobCrewsRepository(api);
    this.documents = new JobDocumentRepository(api);
    this.expenses = new JobExpenseRepository(api);
    this.invoices = new JobInvoicesRepository(api);
    this.items = new JobItemRepository(api);
    this.material = new JobMaterialRepository(api);
    this.notes = new JobNoteRepository(api);
    this.parentJob = new JobParentJobRepository(api);
    this.purchaseOrders = new JobPurchaseOrderRepository(api);
    this.inventorypurchaseOrders = new JobInventoryPurchaseOrderRepository(api);
    this.recommendations = new JobRecommendationRepository(api);
    this.signoffs = new JobSignoffRepository(api);
    this.statuses = new JobJobStatusRepository(api);
    this.timeRates = new JobTimeRateRepository(api);
    this.timeSheets = new JobTimeSheetsRepository(api);
    this.types = new JobJobTypeRepository(api);
    this.linkedJobs = new JobLinkedJobsRepository(api);
  }

  create(job, options) {
    return this._api.post("/v1/jobs", options, job);
  }

  get(id, options) {
    return this._api.get(`/v1/jobs/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/jobs", params);
  }

  search(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/jobs/search", params);
  }

  update(jobId, job, options) {
    return this._api.patch(`/v1/jobs/${jobId}`, options, job);
  }

  completeProcessing(job, options) {
    return this._api.patch(`/v1/jobs/completeprocessing`, options, job);
  }
}

class JobChangeOrdersRepository {
  constructor(api) {
    this._api = api;
  }

  create(jobId, changeOrder, options) {
    return this._api.post(
      `/v1/jobs/${jobId}/changeOrders`,
      options,
      changeOrder
    );
  }

  get(jobId, changeOrderId, options) {
    return this._api.get(
      `/v1/jobs/${jobId}/changeOrders/${changeOrderId}`,
      options
    );
  }
}

class JobMaterialRepository {
  constructor(api) {
    this._api = api;
    this.entries = new JobMaterialEntryRepository(api);
    this.sourcing = new JobMaterialSourcingRepository(api);
    this.images = new JobMaterialImageRepository(api);
  }

  create(jobId, material, options) {
    return this._api.post(`/v1/jobs/${jobId}/material`, options, material);
  }

  get(jobId, materialId, options) {
    return this._api.get(`/v1/jobs/${jobId}/material/${materialId}`, options);
  }

  query(jobId, criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get(`/v1/jobs/${jobId}/material`, params);
  }

  update(jobId, materialId, changes, options) {
    return this._api.patch(
      `/v1/jobs/${jobId}/material/${materialId}`,
      options,
      changes
    );
  }

  autosource(jobId, requiredDate, options) {
    return this._api.post(
      `/v1/jobs/${jobId}/material/autosource`,
      options,
      requiredDate
    );
  }
}

class JobMaterialEntryRepository {
  constructor(api) {
    this._api = api;
  }

  create(jobId, materialId, entry, options) {
    return this._api.post(
      `/v1/jobs/${jobId}/material/${materialId}/entries`,
      options,
      entry
    );
  }

  createWasteEntry(jobId, materialId, entry, options) {
    return this._api.post(
      `/v1/jobs/${jobId}/material/${materialId}/wasteentry`,
      options,
      entry
    );
  }

  createWarehouseWaste(jobId, materialId, warehouseId, entry, options) {
    return this._api.post(
      `/v1/jobs/${jobId}/material/${materialId}/wasteentry/${warehouseId}`,
      options,
      entry
    );
  }

  delete(jobId, materialId, entryId, options) {
    return this._api.delete(
      `/v1/jobs/${jobId}/material/${materialId}/entries/${entryId}`,
      options
    );
  }

  get(jobId, materialId, entryId, options) {
    return this._api.get(
      `/v1/jobs/${jobId}/material/${materialId}/entries/${entryId}`,
      options
    );
  }

  query(jobId, materialId, criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get(
      `/v1/jobs/${jobId}/material/${materialId}/entries`,
      params
    );
  }

  update(jobId, materialId, entryId, changes, options) {
    return this._api.patch(
      `/v1/jobs/${jobId}/material/${materialId}/entries/${entryId}`,
      options,
      changes
    );
  }
}

class JobMaterialImageRepository {
  constructor(api) {
    this._api = api;
  }

  get(jobId, materialId, imageId, options) {
    return this._api.get(
      `/v1/jobs/${jobId}/material/${materialId}/images/${imageId}`,
      options
    );
  }
}

class JobMaterialSourcingRepository {
  constructor(api) {
    this._api = api;
  }

  create(jobId, materialId, sourcing, options) {
    return this._api.post(
      `/v1/jobs/${jobId}/material/${materialId}/sourcing`,
      options,
      sourcing
    );
  }

  delete(jobId, materialId, sourcingId, options) {
    return this._api.delete(
      `/v1/jobs/${jobId}/material/${materialId}/sourcing/${sourcingId}`,
      options
    );
  }

  get(jobId, materialId, sourcingId, options) {
    return this._api.get(
      `/v1/jobs/${jobId}/material/${materialId}/sourcing/${sourcingId}`,
      options
    );
  }

  query(jobId, materialId, criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get(
      `/v1/jobs/${jobId}/material/${materialId}/sourcing`,
      params
    );
  }

  update(jobId, materialId, sourcingId, changes, options) {
    return this._api.patch(
      `/v1/jobs/${jobId}/material/${materialId}/sourcing/${sourcingId}`,
      options,
      changes
    );
  }

  patch(jobId, materialId, sourcingId, changes, options) {
    return this._api.patch(
      `/v1/jobs/${jobId}/material/${materialId}/sourcing/${sourcingId}`,
      options,
      changes
    );
  }
}

class JobNoteRepository {
  constructor(api) {
    this._api = api;
  }

  create(jobId, note, options) {
    return this._api.post(`/v1/jobs/${jobId}/notes`, options, note);
  }
}

class JobParentJobRepository {
  constructor(api) {
    this._api = api;
  }

  get(jobId, options) {
    return this._api.get(`/v1/jobs/${jobId}/parentJob`, options);
  }
}

class JobPurchaseOrderRepository {
  constructor(api) {
    this._api = api;
  }

  query(jobId, criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get(`/v1/jobs/${jobId}/purchaseOrders`, params);
  }
}

class JobInventoryPurchaseOrderRepository {
  constructor(api) {
    this._api = api;
  }

  query(jobId, criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get(`/v1/jobs/${jobId}/inventoryPurchaseOrders`, params);
  }
}

class JobRecommendationRepository {
  constructor(api) {
    this._api = api;
  }

  create(jobId, recommendation, options) {
    const { requestId, ...params } = options || {};
    return this._api.post(
      `/v1/jobs/${jobId}/recommendations`,
      options,
      recommendation,
      {
        "Request-ID": requestId,
      }
    );
  }

  delete(jobId, recommendationId, options) {
    return this._api.delete(
      `/v1/jobs/${jobId}/recommendations/${recommendationId}`,
      options
    );
  }

  get(jobId, recommendationId, options) {
    return this._api.get(
      `/v1/jobs/${jobId}/recommendations/${recommendationId}`,
      options
    );
  }

  patch(jobId, recommendationId, changes, options) {
    return this.update(jobId, recommendationId, changes, options);
  }

  update(jobId, recommendationId, changes, options) {
    return this._api.patch(
      `/v1/jobs/${jobId}/recommendations/${recommendationId}`,
      options,
      changes
    );
  }

  query(jobId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/jobs/${jobId}/recommendations`, params);
  }
}

class JobSignoffRepository {
  constructor(api) {
    this._api = api;
  }

  create(jobId, signoff, options) {
    const { requestId, ...params } = options || {};
    return this._api.post(`/v1/jobs/${jobId}/signoffs`, options, signoff, {
      "Request-ID": requestId,
    });
  }

  get(jobId, signoffId, options) {
    return this._api.get(`/v1/jobs/${jobId}/signoffs/${signoffId}`, options);
  }

  query(jobId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/jobs/${jobId}/signoffs`, params);
  }
}

class JobTimeRateRepository {
  constructor(api) {
    this._api = api;
  }

  query(jobId, criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get(`/v1/jobs/${jobId}/timeRates`, params);
  }

  put(jobId, timeRate, options) {
    return this._api.put(`/v1/jobs/${jobId}/timeRates`, options, timeRate);
  }
}

class JobTimeSheetsRepository {
  constructor(api) {
    this._api = api;
  }

  create(jobId, timeSheet, options) {
    const { requestId, ...params } = options || {};
    return this._api.post(`/v1/jobs/${jobId}/timesheets`, options, timeSheet, {
      "Request-ID": requestId,
    });
  }

  createCrewTimesheets(jobId, crewId, timeSheet, options) {
    const { requestId, ...params } = options || {};
    return this._api.post(
      `/v1/jobs/${jobId}/crews/${crewId}/timesheets`,
      options,
      timeSheet,
      {
        "Request-ID": requestId,
      }
    );
  }

  delete(jobId, timeSheetId, options) {
    return this._api.delete(
      `/v1/jobs/${jobId}/timesheets/${timeSheetId}`,
      options
    );
  }

  get(jobId, timeSheetId, options) {
    return this._api.get(
      `/v1/jobs/${jobId}/timesheets/${timeSheetId}`,
      options
    );
  }

  query(jobId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/jobs/${jobId}/timesheets`, params);
  }

  update(jobId, timeSheetId, changes, options) {
    return this._api.patch(
      `/v1/jobs/${jobId}/timesheets/${timeSheetId}`,
      options,
      changes
    );
  }
  updateCrewTimesheets(jobId, timeSheetId, changes, options) {
    return this._api.patch(
      `/v1/jobs/${jobId}/timesheets/crew/${timeSheetId}`,
      options,
      changes
    );
  }
}

class JobLinkedJobsRepository {
  constructor(api) {
    this._api = api;
  }
  query(jobId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/jobs/${jobId}/linkedjobs`, params);
  }
}

/**
 * Deprecated. Use JobProApi.jobStatuses.
 */
class JobJobStatusRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/jobs/statuses", params);
  }
}

class JobStatusRepository {
  constructor(api) {
    this._api = api;
  }

  create(jobStatus, options) {
    return this._api.post("/v1/jobStatuses", options, jobStatus);
  }

  delete(id, options) {
    return this._api.delete(`/v1/jobStatuses/${id}`, options);
  }

  get(id, options) {
    return this._api.get(`/v1/jobStatuses/${id}`, options);
  }

  query(criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get("/v1/jobStatuses", params);
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/jobStatuses/${id}`, options, changes);
  }
}

/**
 * Deprecated. Use JobProApi.jobTypes.
 */
class JobJobTypeRepository {
  constructor(api) {
    this._api = api;
  }

  /**
   * Deprecated. Use JobProApi.jobTypes.query.
   */
  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/jobs/types", params);
  }
}

class JobTypeRepository {
  constructor(api) {
    this._api = api;
  }

  create(jobType, options) {
    return this._api.post("/v1/jobTypes", options, jobType);
  }

  delete(id, options) {
    return this._api.delete(`/v1/jobTypes/${id}`, options);
  }

  get(id, options) {
    return this._api.get(`/v1/jobTypes/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/jobTypes", params);
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/jobTypes/${id}`, options, changes);
  }
}

class LaborMultiplierRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/labor-multipliers", params);
  }
}

class ManufacturerRepository {
  constructor(api) {
    this._api = api;
  }

  get(id, options) {
    return this._api.get(`/v1/manufacturer/${id}`, options);
  }

  search(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/manufacturers/search", params);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/manufacturers", params);
  }
}

class MaterialMultiplierRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/material-multipliers", params);
  }
}

class MerchantServicesRepository {
  constructor(api) {
    this._api = api;
    this.configs = new MerchantServicesConfigsRepository(api);
    this.tokens = new MerchantServicesTokenRepository(api);
    this.preauth = new MerchantServicesPreAuthRepository(api);
    this.payments = new MerchantServicesPaymentRepository(api);
  }
}

class MerchantServicesConfigsRepository {
  constructor(api) {
    this._api = api;
  }

  create(config, options) {
    return this._api.post("/v1/merchantservices/configs", options, config);
  }

  delete(id, options) {
    return this._api.delete(`/v1/merchantservices/configs/${id}`, options);
  }

  get(id, options) {
    return this._api.get(`/v1/merchantservices/configs/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/merchantservices/configs", params);
  }

  update(id, changes, options) {
    return this._api.patch(
      `/v1/merchantservices/configs/${id}`,
      options,
      changes
    );
  }
}

class MerchantServicesPaymentRepository {
  constructor(api) {
    this._api = api;
  }

  get(paymentId) {
    return this._api.get(`/v1/merchantservices/payments/${paymentId}`);
  }
}

class MerchantServicesTokenRepository {
  constructor(api) {
    this._api = api;
  }

  get(customerId, options) {
    return this._api.get(
      `/v1/merchantservices/payment-tokens/${customerId}`,
      options
    );
  }

  create(customerId, paymentToken, options) {
    return this._api.post(
      `/v1/merchantservices/payment-tokens/${customerId}`,
      options,
      paymentToken
    );
  }
}

class MerchantServicesPreAuthRepository {
  constructor(api) {
    this._api = api;
  }

  getBid(bidId, options) {
    return this._api.get(
      `/v1/merchantservices/pending-job/${bidId}/pre-auth`,
      options
    );
  }

  createBid(bidId, processCreditCard, options) {
    return this._api.post(
      `/v1/merchantservices/pending-job/${bidId}/pre-auth`,
      options,
      processCreditCard
    );
  }

  getJob(jobId, options) {
    return this._api.get(`/v1/merchantservices/job/${jobId}/pre-auth`, options);
  }

  getInvoice(invoiceId, options) {
    return this._api.get(
      `/v1/merchantservices/invoice/${invoiceId}/pre-auth`,
      options
    );
  }

  delete(transactionId, options) {
    return this._api.delete(
      `/v1/merchantservices/pre-auth/${transactionId}`,
      options
    );
  }
}

class NoteTemplateRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/note-templates", params);
  }
}

class OfficeRepository {
  constructor(api) {
    this._api = api;
  }

  get(id, options) {
    return this._api.get(`/v1/offices/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/offices", params);
  }
}

class PaymentRepository {
  constructor(api) {
    this._api = api;
    this.invoicePayments = new PaymentInvoicePaymentRepository(api);
  }

  create(payment, options) {
    return this._api.post("/v1/payments", options, payment);
  }
  bulkcreate(payments, options) {
    return this._api.post("/v1/payments/bulkcreate", options, payments);
  }

  bankcodes(options) {
    return this._api.get("/v1/payments/bankcodes", options);
  }

  get(id, options) {
    return this._api.get(`/v1/payments/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/payments", params);
  }

  querybankoffices(bankId, criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get(`/v1/payments/${bankId}/offices`, params);
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/payments/${id}`, options, changes);
  }

  voidpayment(paymentId, options, criteria) {
    return this._api.post(
      `/v1/payments/voidpayment/${paymentId}`,
      options,
      criteria
    );
  }
}

class PaymentInvoicePaymentRepository {
  constructor(api) {
    this._api = api;
  }

  create(paymentId, invoicePayment, options) {
    return this._api.post(
      `/v1/payments/${paymentId}/invoicePayments`,
      options,
      invoicePayment
    );
  }

  put(paymentId, invoicePayments, options) {
    return this._api.put(
      `/v1/payments/${paymentId}/invoicePayments`,
      options,
      invoicePayments
    );
  }
}

class PayrollDocumentTemplateRepository {
  constructor(api) {
    this._api = api;
  }

  delete(id, options) {
    return this._api.delete(`/v1/payrollDocumentTemplates/${id}`, options);
  }

  get(id, options) {
    return this._api.get(`/v1/payrollDocumentTemplates/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/payrollDocumentTemplates", params);
  }

  update(id, changes, options) {
    return this._api.patch(
      `/v1/payrollDocumentTemplates/${id}`,
      options,
      changes
    );
  }
}

class PropertyRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/properties", params);
  }

  getByID(id, options) {
    return this._api.get(`/v1/properties/${id}`, options);
  }

  getByCustomerID(id, options) {
    return this._api.get(`/v1/properties/customer/${id}`, options);
  }

  create(property, options) {
    return this._api.post("/v1/properties", options, property);
  }
}

class ProposalAgreements {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/proposal-agreements", params);
  }
}

class ProposalEmailTemplatesRepository {
  constructor(api) {
    this._api = api;
  }
  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/proposal-email-template", params);
  }
}

class ProposalAgreementTemplateRepository {
  constructor(api) {
    this._api = api;
  }

  delete(id, options) {
    return this._api.delete(`/v1/proposalAgreementTemplates/${id}`, options);
  }

  get(id, options) {
    return this._api.get(`/v1/proposalAgreementTemplates/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/proposalAgreementTemplates", params);
  }

  update(id, changes, options) {
    return this._api.patch(
      `/v1/proposalAgreementTemplates/${id}`,
      options,
      changes
    );
  }
}

class ProposalPriceRestrictionsRepository {
  constructor(api) {
    this._api = api;
  }

  create(priceRestriction, options) {
    return this._api.post(
      "/v1/proposalPriceRestrictions",
      options,
      priceRestriction
    );
  }

  delete(id, options) {
    return this._api.delete(`/v1/proposalPriceRestrictions/${id}`, options);
  }

  get(id, options) {
    return this._api.get(`/v1/proposalPriceRestrictions/${id}`, options);
  }

  put(id, priceRestriction, options) {
    return this._api.put(
      `/v1/proposalPriceRestrictions/${id}`,
      options,
      priceRestriction
    );
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/proposalPriceRestrictions", params);
  }
}

class ProposalTemplateRepository {
  constructor(api) {
    this._api = api;
  }

  delete(id, options) {
    return this._api.delete(`/v1/proposalTemplates/${id}`, options);
  }

  get(id, options) {
    return this._api.get(`/v1/proposalTemplates/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/proposalTemplates", params);
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/proposalTemplates/${id}`, options, changes);
  }
}

class ProposalTemplateDesignRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/proposal-template-designs", params);
  }
}

class PurchaseOrderRepository {
  constructor(api) {
    this._api = api;
    this.documents = new PurchaseOrderDocumentRepository(api);
    this.items = new PurchaseOrderItemRepository(api);
    this.notes = new PurchaseOrderNoteRepository(api);
    this.statuses = new PurchaseOrderStatusRepository(api);
  }

  create(purchaseOrder, options) {
    return this._api.post("/v1/purchaseOrders", options, purchaseOrder);
  }

  delete(id, options) {
    return this._api.delete(`/v1/purchaseOrders/${id}`, options);
  }

  get(id, options) {
    return this._api.get(`/v1/purchaseOrders/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/purchaseOrders", params);
  }

  search(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/purchaseOrders/search", params);
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/purchaseOrders/${id}`, options, changes);
  }
}

class PhysicalCountRepository {
  constructor(api) {
    this._api = api;
  }

  create(physicalCount, options) {
    return this._api.post("/v1/physicalCounts", options, physicalCount);
  }

  delete(id, options) {
    return this._api.delete(`/v1/physicalCounts/${id}`, options);
  }

  get(id, options) {
    return this._api.get(`/v1/physicalCounts/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/physicalCounts", params);
  }

  search(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/physicalCounts/search", params);
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/physicalCounts/${id}`, options, changes);
  }
}

class InventoryPurchaseOrderRepository {
  constructor(api) {
    this._api = api;
    this.documents = new InventoryPurchaseOrderDocumentRepository(api);
    this.items = new InventoryPurchaseOrderItemRepository(api);
    this.notes = new InventoryPurchaseOrderNoteRepository(api);
  }

  create(purchaseOrder, options) {
    return this._api.post("/v1/inv_purchaseorders", options, purchaseOrder);
  }

  get(id, options, requestHeaders) {
    return this._api.get(
      `/v1/inv_purchaseorders/${id}`,
      options,
      requestHeaders
    );
  }

  query(criteria, options, requestHeaders) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/inv_purchaseorders", params, requestHeaders);
  }

  search(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/inv_purchaseorders/search", params);
  }

  receive(id, receive, options) {
    return this._api.post(
      `/v1/inv_purchaseorders/${id}/receive`,
      options,
      receive
    );
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/inv_purchaseorders/${id}`, options, changes);
  }
}

class PurchaseOrderDocumentRepository {
  constructor(api) {
    this._api = api;
  }

  create(purchaseOrderId, document, options) {
    return this._api.post(
      `/v1/purchaseOrders/${purchaseOrderId}/documents`,
      options,
      document
    );
  }

  delete(purchaseOrderId, documentId, options) {
    return this._api.delete(
      `/v1/purchaseOrders/${purchaseOrderId}/documents/${documentId}`,
      options
    );
  }

  get(purchaseOrderId, documentId, options) {
    return this._api.get(
      `/v1/purchaseOrders/${purchaseOrderId}/documents/${documentId}`,
      options
    );
  }

  query(purchaseOrderId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(
      `/v1/purchaseOrders/${purchaseOrderId}/documents`,
      params
    );
  }
}

class PurchaseOrderItemRepository {
  constructor(api) {
    this._api = api;
  }

  create(purchaseOrderId, purchaseOrderItem, options) {
    return this._api.post(
      `/v1/purchaseOrders/${purchaseOrderId}/items`,
      options,
      purchaseOrderItem
    );
  }

  delete(purchaseOrderId, purchaseOrderItemId, options) {
    return this._api.delete(
      `/v1/purchaseOrders/${purchaseOrderId}/items/${purchaseOrderItemId}`,
      options
    );
  }

  get(purchaseOrderId, purchaseOrderItemId, options) {
    return this._api.get(
      `/v1/purchaseOrders/${purchaseOrderId}/items/${purchaseOrderItemId}`,
      options
    );
  }

  query(purchaseOrderId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/purchaseOrders/${purchaseOrderId}/items`, params);
  }

  update(purchaseOrderId, purchaseOrderItemId, changes, options) {
    return this._api.patch(
      `/v1/purchaseOrders/${purchaseOrderId}/items/${purchaseOrderItemId}`,
      options,
      changes
    );
  }
}

class PurchaseOrderNoteRepository {
  constructor(api) {
    this._api = api;
  }

  create(purchaseOrderId, note, options) {
    return this._api.post(
      `/v1/purchaseOrders/${purchaseOrderId}/notes`,
      options,
      note
    );
  }

  delete(purchaseOrderId, noteId, options) {
    return this._api.delete(
      `/v1/purchaseOrders/${purchaseOrderId}/notes/${noteId}`,
      options
    );
  }

  get(purchaseOrderId, noteId, options) {
    return this._api.get(
      `/v1/purchaseOrders/${purchaseOrderId}/notes/${noteId}`,
      options
    );
  }

  query(purchaseOrderId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/purchaseOrders/${purchaseOrderId}/notes`, params);
  }

  update(purchaseOrderId, noteId, changes, options) {
    return this._api.patch(
      `/v1/purchaseOrders/${purchaseOrderId}/notes/${noteId}`,
      options,
      changes
    );
  }
}

class PurchaseOrderStatusRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/purchaseOrders/statuses", params);
  }
}

class InventoryPurchaseOrderDocumentRepository {
  constructor(api) {
    this._api = api;
  }

  create(purchaseOrderId, document, options) {
    return this._api.post(
      `/v1/inv_purchaseorders/${purchaseOrderId}/documents`,
      options,
      document
    );
  }

  delete(purchaseOrderId, documentId, options) {
    return this._api.delete(
      `/v1/inv_purchaseorders/${purchaseOrderId}/documents/${documentId}`,
      options
    );
  }

  get(purchaseOrderId, documentId, options) {
    return this._api.get(
      `/v1/inv_purchaseorders/${purchaseOrderId}/documents/${documentId}`,
      options
    );
  }

  query(purchaseOrderId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(
      `/v1/inv_purchaseorders/${purchaseOrderId}/documents`,
      params
    );
  }
}

class InventoryPurchaseOrderItemRepository {
  constructor(api) {
    this._api = api;
  }

  get(purchaseOrderId, purchaseOrderItemId, options, requestHeaders) {
    return this._api.get(
      `/v1/inv_purchaseorders/${purchaseOrderId}/items/${purchaseOrderItemId}`,
      options,
      requestHeaders
    );
  }

  add(purchaseOrderId, item, options) {
    return this._api.post(
      `/v1/inv_purchaseorders/${purchaseOrderId}/items`,
      options,
      item
    );
  }

  query(purchaseOrderId, criteria, options, requestHeaders) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(
      `/v1/inv_purchaseorders/${purchaseOrderId}/items`,
      params,
      requestHeaders
    );
  }

  update(purchaseOrderId, purchaseOrderItemId, purchaseOrderItem, options) {
    return this._api.patch(
      `/v1/inv_purchaseorders/${purchaseOrderId}/items/${purchaseOrderItemId}`,
      options,
      purchaseOrderItem
    );
  }
}

class InventoryPurchaseOrderItemsRepository {
  constructor(api) {
    this._api = api;
  }

  get(purchaseOrderItemId, options, requestHeaders) {
    return this._api.get(
      `/v1/inv_purchaseorders/items/${purchaseOrderItemId}`,
      options,
      requestHeaders
    );
  }

  query(criteria, options, requestHeaders) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(
      `/v1/inv_purchaseorders/items`,
      params,
      requestHeaders
    );
  }

  update(purchaseOrderItemId, purchaseOrderItem, options) {
    return this._api.patch(
      `/v1/inv_purchaseorders/items/${purchaseOrderItemId}`,
      options,
      purchaseOrderItem
    );
  }

  getByMaterialId(materialId, options, requestHeaders) {
    return this._api.get(
      `/v1/inv_purchaseorders/items/orderedbyjobitem/${materialId}`,
      options,
      requestHeaders
    );
  }

  getByJobId(jobId, options, requestHeaders) {
    return this._api.get(
      `/v1/inv_purchaseorders/items/orderedbyjob/${jobId}`,
      options,
      requestHeaders
    );
  }
  adjustPickedItems(purchaseOrderId, purchaseOrderItems, options) {
    return this._api.patch(
      `/v1/inv_purchaseorders/${purchaseOrderId}/pickeditems`,
      options,
      purchaseOrderItems
    );
  }
}

class InventoryPurchaseOrderNoteRepository {
  constructor(api) {
    this._api = api;
  }

  create(purchaseOrderId, note, options) {
    return this._api.post(
      `/v1/inv_purchaseorders/${purchaseOrderId}/notes`,
      options,
      note
    );
  }

  delete(purchaseOrderId, noteId, options) {
    return this._api.delete(
      `/v1/inv_purchaseorders/${purchaseOrderId}/notes/${noteId}`,
      options
    );
  }

  get(purchaseOrderId, noteId, options) {
    return this._api.get(
      `/v1/inv_purchaseorders/${purchaseOrderId}/notes/${noteId}`,
      options
    );
  }

  query(purchaseOrderId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(
      `/v1/inv_purchaseorders/${purchaseOrderId}/notes`,
      params
    );
  }

  update(purchaseOrderId, noteId, changes, options) {
    return this._api.patch(
      `/v1/inv_purchaseorders/${purchaseOrderId}/notes/${noteId}`,
      options,
      changes
    );
  }
}

class PreferredPaymentMethodRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/preferredPaymentMethods", params);
  }
}

class ReferralSourceRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/referralSources", params);
  }
}

class RequestTypeQuestionRepository {
  constructor(api) {
    this._api = api;
  }

  create(requestTypeId, question, options) {
    return this._api.post(
      `/v1/requestTypes/${requestTypeId}/questions`,
      options,
      question
    );
  }

  get(requestTypeId, options) {
    return this._api.get(
      `/v1/requestTypes/${requestTypeId}/questions`,
      options
    );
  }

  query(requestTypeId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/requestTypes/${requestTypeId}/questions`, params);
  }

  update(requestTypeId, questionId, changes, options) {
    return this._api.patch(
      `/v1/requestTypes/${requestTypeId}/questions/${questionId}`,
      options,
      changes
    );
  }
}

class RequestTypeRepository {
  constructor(api) {
    this._api = api;
    this.questions = new RequestTypeQuestionRepository(api);
  }

  create(requestType, options) {
    return this._api.post("/v1/requestTypes", options, requestType);
  }

  get(requestTypeId, options) {
    return this._api.get(`/v1/requestTypes/${requestTypeId}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/requestTypes", params);
  }

  update(requestTypeId, changes, options) {
    return this._api.patch(
      `/v1/requestTypes/${requestTypeId}`,
      options,
      changes
    );
  }
}

class ResourceRepository {
  constructor(api) {
    this._api = api;
    this.deliveries = new ResourceDeliveryRepository(api);
    this.documents = new ResourceDocumentRepository(api);
    this.inspectionChecklists = new ResourceInspectionChecklistRepository(api);
    this.loadTicket = new ResourceLoadTicketRepository(api);
    this.timeRates = new ResourceTimeRateRepository(api);
  }

  get(resourceId, options) {
    return this._api.get(`/v1/resources/${resourceId}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/resources", params);
  }

  update(resourceId, changes, options) {
    return this._api.patch(`/v1/resources/${resourceId}`, options, changes);
  }
}

class ResourceDeliveryRepository {
  constructor(api) {
    this._api = api;
  }

  query(resourceId, criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get(`/v1/resources/${resourceId}/deliveries`, params);
  }
}

class ResourceDocumentRepository {
  constructor(api) {
    this._api = api;
  }

  create(resourceId, document, options) {
    return this._api.post(
      `/v1/resources/${resourceId}/documents`,
      options,
      document
    );
  }

  delete(resourceId, documentId, options) {
    return this._api.delete(
      `/v1/resources/${resourceId}/documents/${documentId}`,
      options
    );
  }

  get(resourceId, documentId, options) {
    return this._api.get(
      `/v1/resources/${resourceId}/documents/${documentId}`,
      options
    );
  }

  query(resourceId, criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get(`/v1/resources/${resourceId}/documents`, params);
  }
}

class ResourceInspectionChecklistRepository {
  constructor(api) {
    this._api = api;
  }

  create(resourceId, inspectionChecklist, options) {
    return this._api.post(
      `/v1/resources/${resourceId}/inspection-checklists`,
      options,
      inspectionChecklist
    );
  }

  get(resourceId, inspectionChecklistId, options) {
    return this._api.get(
      `/v1/resources/${resourceId}/inspection-checklists/${inspectionChecklistId}`,
      options
    );
  }

  query(resourceId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(
      `/v1/resources/${resourceId}/inspection-checklists`,
      params
    );
  }

  update(resourceId, inspectionChecklistId, inspectionChecklist, options) {
    return this._api.patch(
      `/v1/resources/${resourceId}/inspection-checklists/${inspectionChecklistId}`,
      options,
      inspectionChecklist
    );
  }
}

class ResourceLoadTicketRepository {
  constructor(api) {
    this._api = api;
  }

  get(resourceId, options) {
    return this._api.get(`/v1/resources/${resourceId}/load-ticket`, options);
  }
}

class ResourcePayTypeRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get("/v1/resourcePayTypes", params);
  }
}

class ResourceTimeRateRepository {
  constructor(api) {
    this._api = api;
  }

  query(resourceId, criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get(`/v1/resources/${resourceId}/timeRates`, params);
  }

  put(resourceId, timeRate, options) {
    return this._api.put(
      `/v1/resources/${resourceId}/timeRates`,
      options,
      timeRate
    );
  }
}

class SettingsRepository {
  constructor(api) {
    this._api = api;
  }

  get(options) {
    return this._api.get(`/v1/settings`, options);
  }

  update(settings, options) {
    return this._api.patch(`/v1/settings`, options, settings);
  }
}

class StandardCrewRepository {
  constructor(api) {
    this._api = api;
  }

  create(crew, options) {
    return this._api.post("/v1/standard-crews", options, crew);
  }

  delete(id, options) {
    return this._api.delete(`/v1/standard-crews/${id}`, options);
  }

  get(id, options) {
    return this._api.get(`/v1/standard-crews/${id}`, options);
  }

  put(id, crew, options) {
    return this._api.put(`/v1/standard-crews/${id}`, options, crew);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/standard-crews", params);
  }
}

class StageTypeRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/stage-types", params);
  }
}

class StockImageRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/stock-images", params);
  }
}

class StockOrderRepository {
  constructor(api) {
    this._api = api;
    this.items = new StockOrderItemSearchRepository(api);
  }
}

class StockOrderItemSearchRepository {
  constructor(api) {
    this._api = api;
  }

  searchpendingjoborders(query, options) {
    const params = JobProAPI.merge(query, options);
    return this._api.get(`/v1/stockorders/pendingjoborders/`, params);
  }

  searchbelowthreshold(query, options) {
    const params = JobProAPI.merge(query, options);
    return this._api.get("/v1/stockorders/belowthreshold", params);
  }

  searchotheritems(query, options) {
    const params = JobProAPI.merge(query, options);
    return this._api.get("/v1/stockorders/otheritems", params);
  }
}

class SupplierRepository {
  constructor(api) {
    this._api = api;
  }

  create(supplier, options) {
    return this._api.post("/v1/suppliers", options, supplier);
  }
  get(id, options) {
    return this._api.get(`/v1/suppliers/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/suppliers", params);
  }
}

class SummaryReportsRepository {
  constructor(api) {
    this._api = api;
  }
  getAgingSummary(AgingSummaryReportRequest, options) {
    return this._api.get(
      "/v1/summary-report/aging-summary",
      AgingSummaryReportRequest,
      options
    );
  }
  getAgingSummaryPDF(AgingSummaryReportRequest, options) {
    return this._api.get(
      "/v1/summary-report/aging-summary-pdf",
      AgingSummaryReportRequest,
      options,
      { expectedResponseType: "blob" }
    );
  }
  getAgedInvoicesSummary(AgedInvoicesReportRequest, options) {
    return this._api.get(
      "/v1/summary-report/aged-invoice-summary",
      AgedInvoicesReportRequest,
      options
    );
  }
  getInvoiceSumamry(InvoiceSummaryReportRequest, options) {
    return this._api.get(
      "/v1/summary-report/invoice-summary",
      InvoiceSummaryReportRequest,
      options
    );
  }
  getInvoiceItemSummary(InvoiceItemSummaryReportRequest, options) {
    return this._api.get(
      "/v1/summary-report/invoice-summary-item-detail",
      InvoiceItemSummaryReportRequest,
      options
    );
  }
}

class TaxScheduleRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get("/v1/taxSchedules", params);
  }
}

class TemplateCategoryRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get("/v1/templateCategories", params);
  }
}

class TemplateRepository {
  constructor(api) {
    this._api = api;
    this.offices = new TemplateOfficeRepository(api);
    this.documents = new TemplateDocumentRepository(api);
  }
  create(template, options) {
    return this._api.post("/v1/templates", options, template);
  }
  clone(templatesId, options) {
    return this._api.post(`/v1/templates/${templatesId}/clone`, options);
  }
  get(id, options) {
    return this._api.get(`/v1/templates/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/templates", params);
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/templates/${id}`, options, changes);
  }
  getByBidId(bidId, options) {
    return this._api.get(`/v1/templates/bid/${bidId}`, options);
  }
  getRecentUsage(templateId, options) {
    return this._api.get(`/v1/templates/${templateId}/recent-usage`, options);
  }
  getTemplateTotalReport(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/templates/template-total-report", params);
  }
}
class TemplateDocumentRepository {
  constructor(api) {
    this._api = api;
  }

  create(templateId, document, options) {
    return this._api.post(
      `/v1/templates/${templateId}/documents`,
      options,
      document
    );
  }

  get(templateId, documentId, options) {
    return this._api.get(
      `/v1/templates/${templateId}/documents/${documentId}`,
      options
    );
  }

  query(templateId, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/templates/${templateId}/documents`, params);
  }
  delete(templateId, documentId, options) {
    return this._api.delete(
      `/v1/templates/${templateId}/documents/${documentId}`,
      options
    );
  }
}

class TemplatePlanRepository {
  constructor(api) {
    this._api = api;
  }
  create(template, options) {
    return this._api.post("/v1/templateplans", options, template);
  }

  get(templateId, options) {
    return this._api.get(`/v1/templateplans/${templateId}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/templateplans", params);
  }
  delete(planName, options) {
    return this._api.delete(`/v1/templateplans/${planName}`, options);
  }
}

class SPRepository {
  constructor(api) {
    this._api = api;
    this.groupNames = new SPGroupNamesRepository(api);
  }

  getChangeOrders(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/supplypro/changeorders", params);
  }
  getOrders(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/supplypro/orders", params);
  }
  searchOrders(bidid, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/supplypro/orders/${bidid}`, params);
  }
  getUnmatchedOrders(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/supplypro/unmatched", params);
  }
  matchOrder(orderid, templateid, options) {
    return this._api.post(
      `/v1/supplypro/match/${orderid}/${templateid}`,
      options
    );
  }
  createOrder(suppypro, options) {
    return this._api.post("/v1/supplypro", options, suppypro);
  }
  sendNotes(orderid, notes, options) {
    return this._api.post(
      `/v1/supplypro/noteresponse/${orderid}`,
      options,
      notes
    );
  }
  sendAcceptedResponse(orderids, options) {
    return this._api.post(`/v1/supplypro/acceptedresponse`, options, orderids);
  }
  searchOrdersByJob(jobid, criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/supplypro/ordersbyjob/${jobid}`, params);
  }
  sendCompletion(orderids, options) {
    return this._api.post(`/v1/supplypro/completeorders`, options, orderids);
  }
  sendUndoCompletion(orderids, options) {
    return this._api.post(
      `/v1/supplypro/undocompleteorders`,
      options,
      orderids
    );
  }
  getErrors(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/supplypro/errors", params);
  }
  deleteError(orderid, options) {
    return this._api.delete(`/v1/supplypro/errors/${orderid}`, options);
  }
  getSettings(options) {
    return this._api.get("/v1/supplypro/settings", options);
  }
  updateSettings(settings, options) {
    return this._api.patch("/v1/supplypro/settings", options, settings);
  }
  generatePDF(orderid, options) {
    return this._api.get(`/v1/supplypro/generate-pdf/${orderid}`, options);
  }
  createSettings(settings, options) {
    return this._api.post("/v1/supplypro/settings", options, settings);
  }
  update(orderid, order, options) {
    return this._api.patch(`/v1/supplypro/update/${orderid}`, options, order);
  }
  getOrdersMissingGroups(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/supplypro/missing-groups", params);
  }
  reprocessOrder(orderid, groupid, options) {
    return this._api.post(
      `/v1/supplypro/reprocess-order/${orderid}/${groupid}`,
      options
    );
  }
  reprocessChangeOrder(changeOrderNumber, groupid) {
    return this._api.post(
      `/v1/supplypro/reprocess-change-order/${changeOrderNumber}/${groupid}`
    );
  }
  getBidTemplates(id, options) {
    return this._api.get(`/v1/supplypro/${id}/templates`, options);
  }
  swapBidTemplate(bidId, templateId, options) {
    return this._api.post(
      `/v1/supplypro/swap-template/${bidId}/${templateId}`,
      options
    );
  }
}

class SPGroupNamesRepository {
  constructor(api) {
    this._api = api;
  }
  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/supplypro/groupnames", params);
  }
  create(groupname, options) {
    return this._api.post("/v1/supplypro/groupnames", options, groupname);
  }
  delete(id, groupname, options) {
    return this._api.delete(
      `/v1/supplypro/groupnames/${id}`,
      options,
      groupname
    );
  }
  update(id, groupname, options) {
    return this._api.patch(
      `/v1/supplypro/groupnames/${id}`,
      options,
      groupname
    );
  }
  addAlias(id, groupNameAlias, options) {
    return this._api.post(
      `/v1/supplypro/groupnames/alias/${id}`,
      options,
      groupNameAlias
    );
  }
  updateAlias(id, groupname, options) {
    return this._api.patch(
      `/v1/supplypro/groupnames/alias/${id}`,
      options,
      groupname
    );
  }
  deleteAlias(id, options) {
    return this._api.delete(`/v1/supplypro/groupnames/alias/${id}`, options);
  }
}

class TemplateOfficeRepository {
  constructor(api) {
    this._api = api;
  }

  create(templatesId, office, options) {
    return this._api.post(
      `/v1/templates/${templatesId}/offices`,
      options,
      office
    );
  }

  delete(templatesId, officeId, options) {
    return this._api.delete(
      `/v1/templates/${templatesId}/offices/${officeId}`,
      options
    );
  }

  query(criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get("/v1/templates", params);
  }
}

class TimeRateRepository {
  constructor(api) {
    this._api = api;
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/timerates", params);
  }
}

class TimesheetRepository {
  constructor(api) {
    this._api = api;
  }

  create(timesheet, options) {
    return this._api.post("/v1/timesheets", options, timesheet);
  }

  delete(id, options) {
    return this._api.delete(`/v1/timesheets/${id}`, options);
  }

  query(criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get("/v1/timesheets", params);
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/timesheets/${id}`, options, changes);
  }
}

class UserRepository {
  constructor(api) {
    this._api = api;
    this.offices = new UserOfficesRepository(api);
    this.organization = new UserOrganizationRepository(api);
    this.permissions = new UserPermissionsRepository(api);
    //this.roles = new UserRolesRepository(api);
  }

  currentUser(options, requestHeaders) {
    return this._api.get(`/v1/users/current`, options, requestHeaders);
  }

  currentUserOffices(options) {
    return this._api.get(`/v1/users/currentOffices`, options);
  }

  get(id, options) {
    return this._api.get(`/v1/users/${id}`, options);
  }

  query(criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get("/v1/users", params);
  }

  usersList(criteria, options) {
    const params = { ...criteria, ...options };
    return this._api.get("/v1/users/usersList", params);
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/users/${id}`, options, changes);
  }
}

class UserOrganizationRepository {
  constructor(api) {
    this._api = api;
    this.settings = new UserOrganizationSettingsRepository(api);
  }
}

class UserOrganizationSettingsRepository {
  constructor(api) {
    this._api = api;
  }
  // Unused (I think) I can't find any reference of this being a valid path. Returns 404. use settingsRepository above for the current user organization settings.
  get(userId, options) {
    return this._api.get(`/v1/users/${userId}/organization/settings`, options);
  }
}

class UserPermissionsRepository {
  constructor(api) {
    this._api = api;
  }

  query(userId, criteria, options, requestHeaders) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(
      `/v1/users/${userId}/permissions`,
      params,
      requestHeaders
    );
  }

  get(userId, permissionId, options, requestHeaders) {
    return this._api.get(
      `/v1/users/${userId}/permissions/${permissionId}`,
      options,
      requestHeaders
    );
  }

  add(userId, permissionItem, options, requestHeaders) {
    return this._api.post(
      `/v1/users/${userId}/permissions`,
      options,
      permissionItem,
      requestHeaders
    );
  }

  update(userId, permissionId, permissionItem, options, requestHeaders) {
    return this._api.patch(
      `/v1/users/${userId}/permissions/${permissionId}`,
      options,
      permissionItem,
      requestHeaders
    );
  }

  unset(userId, permissionId, options, requestHeaders) {
    return this._api.delete(
      `/v1/users/${userId}/permissions/${permissionId}`,
      options,
      requestHeaders
    );
  }

  delete(userId, permissionId, options, requestHeaders) {
    return this._api.delete(
      `/v1/users/${userId}/permissions/${permissionId}`,
      options,
      requestHeaders
    );
  }
}

class UserOfficesRepository {
  constructor(api) {
    this._api = api;
  }

  query(userId, criteria, options, requestHeaders) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/users/${userId}/offices`, params, requestHeaders);
  }

  create(userId, officeItem, options, requestHeaders) {
    return this._api.post(
      `/v1/users/${userId}/offices`,
      options,
      officeItem,
      requestHeaders
    );
  }

  delete(userId, officeId, options, requestHeaders) {
    return this._api.delete(
      `/v1/users/${userId}/offices/${officeId}`,
      options,
      requestHeaders
    );
  }
}

class WarehouseRepository {
  constructor(api) {
    this._api = api;
    this.items = new WarehouseItemRepository(api);
    this.offices = new WarehouseOfficesRepository(api);
  }
  create(warehouse, options) {
    return this._api.post("/v1/warehouses", options, warehouse);
  }

  get(id, options, requestHeaders) {
    return this._api.get(`/v1/warehouses/${id}`, options, requestHeaders);
  }

  query(criteria, options, requestHeaders) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get(`/v1/warehouses`, params, requestHeaders);
  }
}

class WarehouseItemRepository {
  constructor(api) {
    this._api = api;
  }

  //inventory(itemid, criteria, options) {
  //    const params = JobProAPI.merge(criteria, options);
  //    return this._api.get(`/v1/warehouses/items/${itemid}/inventory`, params);
  //}

  //allocations(itemid, criteria, options) {
  //    const params = JobProAPI.merge(criteria, options);
  //    return this._api.get(`/v1/warehouses/items/${itemid}/allocations`, params);
  //}

  //availability(itemid, criteria, options) {
  //    const params = JobProAPI.merge(criteria, options);
  //    return this._api.get(`/v1/warehouses/items/${itemid}/availability`, params);
  //}

  //stockorders(itemid, criteria, options) {
  //    const params = JobProAPI.merge(criteria, options);
  //    return this._api.get(`/v1/warehouses/items/${itemid}/stockorders`, params);
  //}
}

class WarehouseOfficesRepository {
  constructor(api) {
    this._api = api;
  }

  create(warehouseId, officeId, warehouseOffice, options) {
    return this._api.post(
      `/v1/warehouses/${warehouseId}/offices/${officeId}`,
      options,
      warehouseOffice
    );
  }

  update(warehouseId, officeId, warehouseOffice, options) {
    return this._api.patch(
      `/v1/warehouses/${warehouseId}/offices/${officeId}`,
      options,
      warehouseOffice
    );
  }

  delete(warehouseId, officeId, options) {
    return this._api.delete(
      `/v1/warehouses/${warehouseId}/offices/${officeId}`,
      options
    );
  }
}

class ZipCodeTaxSchedulesRepository {
  constructor(api) {
    this._api = api;
  }

  create(zipCodeTaxSchedule, options) {
    return this._api.post(
      "/v1/zipcodetaxschedule",
      options,
      zipCodeTaxSchedule
    );
  }

  count(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/zipcodetaxschedule/count", params);
  }

  get(id, options) {
    return this._api.get(`/v1/zipcodetaxschedule/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/zipcodetaxschedule", params);
  }

  search(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/zipcodetaxschedule/search", params);
  }
}

class AppointmentTypeRepository {
  constructor(api) {
    this._api = api;
  }

  create(jobType, options) {
    return this._api.post("/v1/appointmentTypes", options, jobType);
  }

  delete(id, options) {
    return this._api.delete(`/v1/appointmentTypes/${id}`, options);
  }

  get(id, options) {
    return this._api.get(`/v1/appointmentTypes/${id}`, options);
  }

  query(criteria, options) {
    const params = JobProAPI.merge(criteria, options);
    return this._api.get("/v1/appointmentTypes", params);
  }

  update(id, changes, options) {
    return this._api.patch(`/v1/appointmentTypes/${id}`, options, changes);
  }
}

// Export JobProAPI for whichever environment is requesting it (falling back to putting it on the window)
(function (root, factory) {
  if (typeof define === "function" && define.amd) {
    define([], factory);
  } else if (typeof exports === "object") {
    module.exports = factory();
  } else {
    root.JobProAPI = factory();
  }
})(window, () => JobProAPI);
